<script>
import {isProxy, toRaw} from 'vue';
import dataTablesComponent from "@/components/subcomponents/dataTablesComponent.vue";
import amhInvoiceGenerationForm from "@/components/subcomponents/amhInvoiceGenerationForm.vue";


import {ModalsContainer, useModal} from 'vue-final-modal'
import vueFinalModal from "@/components/subcomponents/vueFinalModal.vue";


export default {
  inject: ['$axios', '$_', '$shortNumber', '$DateTime', '$formatNumber'],
  emits: ["feedbackForProfile", "filterForPartner"],
  props: {
    loginData: Object,
    searchingInProgress: Number,
    searchResults: Array,
    dirtLists: Object,
    reloadCases: Object
  },
  data() {
    let placeholdersBaseUrl, vm = this;
    if (location.host === 'safeapp.myamh.org') {
      placeholdersBaseUrl = 'https://safeappnode.myamh.org';
    } else {
      placeholdersBaseUrl = 'https://safedevnode.myamh.org';
    }
    return {
      placeholdersBaseUrl: placeholdersBaseUrl,
      tabsView: '',
      myName: `Tester User`,

      draftProfiles: [],
      unapprovedProfiles: [],
      approvedProfiles: [],
      returnedProfiles: [],
      rejectedProfiles: [],

      draftFeedbacks: [],
      unapprovedFeedbacks: [],
      returnedFeedbacks: [],
      closedFeedbacks: [],
      invoiceFeedbacks: [],
      remittanceFeedbacks: [],

      draftProfilesCached: true,
      unapprovedProfilesCached: true,
      approvedProfilesCached: true,
      returnedProfilesCached: true,
      rejectedProfilesCached: true,

      draftFeedbacksCached: true,
      unapprovedFeedbacksCached: true,
      returnedFeedbacksCached: true,
      closedFeedbacksCached: true,

      unapprovedProfilesFiltered: [],

      reportsData: {
        reportObject: {},
        currMonth: '-'
      },
      allProfilesReportsData: {
        reportObject: [],
        columnsMap: {}
      },
      allProfilesReportDataLoaded: false,
      allFeedbacksReportsData: {
        reportObject: [],
        columnsMap: {}
      },
      allFeedbacksReportsDataLoaded: false,

      filterForPartner: '',
      subsectionsChoice: '',
      profileChoices: {
        Representative: [
          {text: 'Draft', endpoint: 'draftProfiles'},
          {text: 'Submitted', endpoint: 'submittedProfiles'},
          {text: 'Approved', endpoint: 'approvedProfiles'},
          {text: 'Returned', endpoint: 'returnedProfiles'},
          {text: 'Rejected', endpoint: 'rejectedProfiles'}
        ],
        Coordinator: [
          {text: 'Submitted', endpoint: 'submittedProfiles'},
          {text: 'Approved', endpoint: 'approvedProfiles'},
          {text: 'Returned', endpoint: 'returnedProfiles'},
          {text: 'Rejected', endpoint: 'rejectedProfiles'}
        ]
      },
      feedbackChoices: {
        Representative: [
          {text: 'Draft', endpoint: 'draftFeedbacks'},
          {text: 'Submitted', endpoint: 'submittedFeedbacks'},
          {text: 'Returned', endpoint: 'returnedFeedbacks'},
          {text: 'Pulled', endpoint: 'closedFeedbacks'}
        ],
        Coordinator: [
          {text: 'Submitted', endpoint: 'submittedFeedbacks'},
          {text: 'Returned', endpoint: 'returnedFeedbacks'},
          {text: 'Pulled', endpoint: 'closedFeedbacks'}
        ]
      },
      financialsChoices: {
        Representative: [
          {text: 'Not Invoiced', endpoint: 'awaitingPartnerInvoiceFinancials'},
          {text: 'Invoiced', endpoint: 'attachedPartnerInvoiceFinancials'},
          {text: 'Generate AMH Invoice', endpoint: 'generateAmhInvoiceFinancials'},
          {text: 'AMH Invoice', endpoint: 'sentAmhInvoiceFinancials'},
          {text: 'Remittance', endpoint: 'awaitingAmhRemittanceFinancials'},
          {text: 'Receipt', endpoint: 'awaitingPartnerReceiptFinancials'},
          {text: 'Verification', endpoint: 'receivedPartnerReceiptFinancials'},
          {text: 'Completed', endpoint: 'completedFinancials'},
        ],
        Coordinator: [
          {text: 'Not Invoiced', endpoint: 'awaitingPartnerInvoiceFinancials'},
          {text: 'Invoiced', endpoint: 'attachedPartnerInvoiceFinancials'},
          {text: 'AMH Invoice', endpoint: 'sentAmhInvoiceFinancials'},
          {text: 'Remittance', endpoint: 'awaitingAmhRemittanceFinancials'},
          {text: 'Receipt', endpoint: 'awaitingPartnerReceiptFinancials'},
          {text: 'Verification', endpoint: 'receivedPartnerReceiptFinancials'},
          {text: 'Completed', endpoint: 'completedFinancials'},
        ]
      },
      reportsChoices: {
        Representative: [
          {text: 'Open', endpoint: 'openStageReports'},
          {text: 'Rejected', endpoint: 'rejectedStageReports'},
          {text: 'Invoice', endpoint: 'invoiceStageReports'},
          {text: 'Pulled', endpoint: 'pulledStageReports'},
          {text: 'Cancelled', endpoint: 'cancelledStageReports'},
          {text: 'Closed', endpoint: 'closedStageReports'},
        ],
        Coordinator: [
          {text: 'Open', endpoint: 'openStageReports'},
          {text: 'Rejected', endpoint: 'rejectedStageReports'},
          {text: 'Invoice', endpoint: 'invoiceStageReports'},
          {text: 'Pulled', endpoint: 'pulledStageReports'},
          {text: 'Cancelled', endpoint: 'cancelledStageReports'},
          {text: 'Closed', endpoint: 'closedStageReports'},
        ]
      },
      adminChoices: {
        Representative: [],
        Coordinator: [
          {text: 'Partners', endpoint: 'partnersAdmin'},
          {text: 'Users', endpoint: 'usersAdmin'},
          {text: 'Pre-approvals', endpoint: 'preapprovalsAdmin'},
        ]
      },
      caseDataChoices: {
        Representative: [
          {text: 'Active', endpoint: 'activeCases'}
        ],
        Coordinator: [
          {text: 'Active', endpoint: 'activeCases'}
        ]
      },
      fundsChoices: {
        Representative: [],
        Coordinator: [
          {text: 'Watsi', endpoint: 'watsiFunds'},
          {text: 'AMH Contingency', endpoint: 'amhcontingencyFunds'},
          {text: 'AMH ECS', endpoint: 'amhecsFunds'},
          {text: 'AMH SVD', endpoint: 'amhsvdyFunds'},
          {text: 'AMH Other', endpoint: 'amhotherFunds'},
        ]
      },
      awaitingPartnerInvoiceFinancialsCount: 0,
      awaitingPartnerRemittanceFinancialsCount: 0,
      totalTableCounts: {
        awaitingPartnerInvoiceFinancials: 0,
        attachedPartnerInvoiceFinancials: 0,
        sentAmhInvoiceFinancials: 0,
        awaitingAmhRemittanceFinancials: 0,
        awaitingPartnerReceiptFinancials: 0,
        receivedPartnerReceiptFinancials: 0,

        profileSubmissionReports: 0,
        feedbackSubmissionReports: 0,
        openStageReports: 0,
        rejectedStageReports: 0,
        invoiceStageReports: 0,
        pulledStageReports: 0,
        cancelledStageReports: 0,
        closedStageReports: 0,
        fundsUtilizationReports: 0,
      },
      allProfilesReportsDataTable: {
        columns: [],
        data: [],
        currentData: vm.currentData
      },
      allFeedbacksReportsDataTable: {
        columns: [],
        data: [],
        currentData: vm.currentData
      },
      IDB: false,
      localDirtyList: [],

      homePageVarsLoaded: false,
      financeReportsYear: {year2026: true, year2025: true, year2024: false},
      financialsType: {outsideapp: true, throughapp: true},
      financeReportsPocket: {
        pocketwatsi: true,
        pocketamhecs: true,
        pocketamhsdv: true,
        pocketamhother: true,
        pocketcontingency: true,
        pocketunallocated: true
      },
      financeReportsGroup_partner_pocket: {partnername: true, p_approvalpocket: true},
      financeReportsGroup_partner: {partnername: true},
      partnerAdminGroup: {country_name: true},
      activeCasesDataGroup: {partner_name: true},
      userAdminGroup: {partner_name: true, role_name: true},
      preapprovalAdminGroup: {partner_name: true, surgery_category: true},
      drawTime: vm.$DateTime.local().setZone('utc').toUnixInteger(),
      updatePatientInvoiceRefresh: vm.$DateTime.local().setZone('utc').toUnixInteger(),
      updateFundAllocationRefresh: vm.$DateTime.local().setZone('utc').toUnixInteger(),
      updateUserAdminRefresh: vm.$DateTime.local().setZone('utc').toUnixInteger(),

      caseViewSelected: false,
      unapprovedProfileCounts: {emergencyCases: 0, electiveCases: 0},
      approvedProfileCounts: {emergencyCases: 0, electiveCases: 0},
      returnedProfileCounts: {emergencyCases: 0, electiveCases: 0},
      rejectedProfileCounts: {emergencyCases: 0, electiveCases: 0},
      submittedFeedbackCounts: {emergencyCases: 0, electiveCases: 0},
      returnedFeedbackCounts: {emergencyCases: 0, electiveCases: 0},
      closedFeedbackCounts: {emergencyCases: 0, electiveCases: 0},

    }
  },
  components: {
    dataTablesComponent,
    ModalsContainer,
    amhInvoiceGenerationForm
  },
  methods: {
    startFeedbackForm: function (profileTitle) {
      let vm = this;
      vm.$emit('feedbackForProfile', profileTitle);
    },
    loadFeedbackForm: function (profileTitle) {
      let vm = this;
      vm.$emit('feedbackForDraft', profileTitle);
    },
    editFeedbackForm: function (profileTitle) {
      let vm = this;
      vm.$emit('feedbackForCorrection', profileTitle);
    },
    loadProfileForm: function (profileIdentifier) {
      let vm = this;
      vm.$emit('continueDraftingProfile', profileIdentifier);
    },
    loadReturnedProfileForm: function (profileTs) {
      let vm = this;
      vm.manageDirtyList('dirty', `returnedProfile_${profileTs}`);
      vm.$emit('continueDraftingReturnedProfile', profileTs);
    },
    loadRejectedProfileForm: function (profileTs) {
      let vm = this;
      vm.$emit('viewProfileRejected', profileTs);
    },
    deleteProfileForm: function (profileTS) {
      let vm = this;
      vm.manageDirtyList('dirty', `returnedProfile_${profileTS}`);
      vm.$emit('deleteReturnedProfile', profileTS);
      vm.$axios
          .post('/profile/action/deleteDraftProfile', {delProfileTS: profileTS, repData: vm.currentData,}, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.loginData.token}`
            }
          })
          .then(async function () {
            await vm.fetchDraftProfiles();
            await vm.fetchReturnedProfiles();
          });
    },
    deleteFeedbackForm: function (profileTS) {
      let vm = this;
      vm.$axios
          .post('/profile/action/deleteDraftFeedback', {delFeedbackTS: profileTS, repData: vm.currentData,}, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.loginData.token}`
            }
          })
          .then(async function () {
            await vm.fetchDraftFeedbacks();
          });
    },
    viewProfileData: function (profileIdentifier, approvingBool) {
      let vm = this;
      vm.$emit('viewProfile', {profileIdentifier: profileIdentifier, approvingBool: approvingBool});
    },
    viewFeedbackData: function (profileIdentifier) {
      let vm = this;
      vm.$emit('viewFeedback', profileIdentifier);
    },
    QAFeedbackData: function (profileIdentifier) {
      let vm = this;
      vm.$emit('qaFeedback', profileIdentifier);
    },
    // saveToIDB: async function (responseDatas, storeName, clearDB) {
    //   let vm = this;
    //   let rawResponseData,
    //       storeDataObj;
    //   if (clearDB) {
    //     await vm.clearPatientsFromDb(vm.IDB, storeName);
    //   }
    //   const storedAccount = localStorage.getItem("account");
    //   let storedAccountPartnerId;
    //   if (storedAccount) {
    //     storedAccountPartnerId = JSON.parse(storedAccount).partnerid;
    //   }
    //   vm.$_.forEach(responseDatas, async function (responseData) {
    //     if (isProxy(responseData)) {
    //       rawResponseData = toRaw(responseData);
    //     } else {
    //       rawResponseData = responseData
    //     }
    //     switch (storeName) {
    //       case 'draftProfiles':
    //         storeDataObj = {
    //           id: parseInt(vm.$_.split(rawResponseData.profileIdentifier, '-')[1]),
    //           caseId: rawResponseData.profileIdentifier,
    //           caseData: rawResponseData,
    //           dirtyState: false,
    //           partnerId: storedAccountPartnerId
    //         }
    //         break;
    //       case 'unapprovedProfiles':
    //         storeDataObj = {
    //           id: parseInt(vm.$_.split(rawResponseData.profileIdentifier, '-')[1]),
    //           caseId: rawResponseData.profileIdentifier,
    //           caseData: rawResponseData,
    //           dirtyState: false,
    //           partnerId: rawResponseData.partnerid
    //         }
    //         break;
    //       case 'approvedProfiles':
    //         storeDataObj = {
    //           id: parseInt(vm.$_.split(rawResponseData.profileIdentifier, '-')[1]),
    //           caseId: rawResponseData.profileIdentifier,
    //           caseData: rawResponseData,
    //           dirtyState: false,
    //           partnerId: rawResponseData.partnerid
    //         }
    //         break;
    //       case 'returnedProfiles':
    //         storeDataObj = {
    //           id: parseInt(vm.$_.split(rawResponseData.profileIdentifier, '-')[1]),
    //           caseId: rawResponseData.profileIdentifier,
    //           caseData: rawResponseData,
    //           dirtyState: false,
    //           partnerId: rawResponseData.partnerid
    //         }
    //         break;
    //       case 'rejectedProfiles':
    //         storeDataObj = {
    //           id: parseInt(vm.$_.split(rawResponseData.profileIdentifier, '-')[1]),
    //           caseId: rawResponseData.profileIdentifier,
    //           caseData: rawResponseData,
    //           dirtyState: false,
    //           partnerId: rawResponseData.partnerid
    //         }
    //         break;
    //       case 'draftFeedbacks':
    //         storeDataObj = {
    //           id: parseInt(vm.$_.split(rawResponseData.profileIdentifier, '-')[1]),
    //           caseId: rawResponseData.profileIdentifier,
    //           caseData: rawResponseData,
    //           dirtyState: false,
    //           partnerId: storedAccountPartnerId
    //         }
    //         break;
    //       case 'unapprovedFeedbacks':
    //         storeDataObj = {
    //           id: parseInt(vm.$_.split(rawResponseData.Identifier, '-')[1]),
    //           caseId: rawResponseData.Identifier,
    //           caseData: rawResponseData,
    //           dirtyState: false,
    //           partnerId: rawResponseData.profile.partnerid
    //         }
    //         break;
    //       case 'returnedFeedbacks':
    //         storeDataObj = {
    //           id: parseInt(vm.$_.split(rawResponseData.Identifier, '-')[1]),
    //           caseId: rawResponseData.Identifier,
    //           caseData: rawResponseData,
    //           dirtyState: false,
    //           partnerId: rawResponseData.profile.partnerid
    //         }
    //         break;
    //       case 'closedFeedbacks':
    //         storeDataObj = {
    //           id: parseInt(vm.$_.split(rawResponseData.Identifier, '-')[1]),
    //           caseId: rawResponseData.Identifier,
    //           caseData: rawResponseData,
    //           dirtyState: false,
    //           partnerId: rawResponseData.profile.partnerid
    //         }
    //         break;
    //       case 'invoiceFeedbacks':
    //         storeDataObj = {
    //           id: parseInt(vm.$_.split(rawResponseData.Identifier, '-')[1]),
    //           caseId: rawResponseData.Identifier,
    //           caseData: rawResponseData,
    //           dirtyState: false,
    //           partnerId: rawResponseData.profile.partnerid
    //         }
    //         break;
    //       case 'remittanceFeedbacks':
    //         storeDataObj = {
    //           id: parseInt(vm.$_.split(rawResponseData.Identifier, '-')[1]),
    //           caseId: rawResponseData.Identifier,
    //           caseData: rawResponseData,
    //           dirtyState: false,
    //           partnerId: rawResponseData.partnerId
    //         }
    //         break;
    //     }
    //     try {
    //       return await vm.addPatientToDb(vm.IDB, storeName, storeDataObj);
    //     } catch (err) {
    //       console.error(err);
    //       return false;
    //     }
    //   });
    // },
    // fetchFromIDB: async function (storeName) {
    //   let vm = this;
    //   let dataKey;
    //   switch (storeName) {
    //     case 'draftProfiles':
    //       dataKey = 'caseData';
    //       break;
    //     case 'unapprovedProfiles':
    //       dataKey = 'caseData';
    //       break;
    //     case 'approvedProfiles':
    //       dataKey = 'caseData';
    //       break;
    //     case 'returnedProfiles':
    //       dataKey = 'caseData';
    //       break;
    //     case 'rejectedProfiles':
    //       dataKey = 'caseData';
    //       break;
    //     case 'draftFeedbacks':
    //       dataKey = 'caseData';
    //       break;
    //     case 'unapprovedFeedbacks':
    //       dataKey = 'caseData';
    //       break;
    //     case 'returnedFeedbacks':
    //       dataKey = 'caseData';
    //       break;
    //     case 'closedFeedbacks':
    //       dataKey = 'caseData';
    //       break;
    //     case 'invoiceFeedbacks':
    //       dataKey = 'caseData';
    //       break;
    //     case 'remittanceFeedbacks':
    //       dataKey = 'caseData';
    //       break;
    //   }
    //
    //   let filterForPartner = localStorage.getItem("filterForPartner");
    //   if (filterForPartner === 'all') {
    //     return await vm.getPatientFromDb(vm.IDB, storeName, false, false, dataKey);
    //   } else {
    //     return await vm.getPatientFromDb(vm.IDB, storeName, filterForPartner, 'partnerId', dataKey);
    //   }
    //
    // },
    loadPatientCards: function (cardCategory) {
      let vm = this;
      return new Promise(function (resolve, reject) {
        try {
          let actionUrl = '',
              responseDataKey = '';
          switch (cardCategory) {
            case 'draftProfiles':
              actionUrl = 'fetchDraftProfiles';
              responseDataKey = 'cleanedProfile';
              break;
            case 'unapprovedProfiles':
              actionUrl = 'fetchUnapprovedProfiles';
              responseDataKey = 'cleanedProfile';
              break;
            case 'approvedProfiles':
              actionUrl = 'fetchApprovedProfiles';
              responseDataKey = 'cleanedProfile';
              break;
            case 'returnedProfiles':
              actionUrl = 'fetchReturnedProfiles';
              responseDataKey = 'cleanedProfile';
              break;
            case 'rejectedProfiles':
              actionUrl = 'fetchRejectedProfiles';
              responseDataKey = 'cleanedProfile';
              break;
            case 'draftFeedbacks':
              actionUrl = 'fetchDraftFeedbacks';
              responseDataKey = 'cleanedFeedback';
              break;
            case 'unapprovedFeedbacks':
              actionUrl = 'fetchUnapprovedFeedbacks';
              responseDataKey = 'mergedFeedback';
              break;
            case 'returnedFeedbacks':
              actionUrl = 'fetchReturnedFeedbacks';
              responseDataKey = 'mergedFeedback';
              break;
            case 'closedFeedbacks':
              actionUrl = 'fetchClosedFeedbacks';
              responseDataKey = 'mergedFeedback';
              break;
            case 'invoiceFeedbacks':
              actionUrl = 'fetchInvoiceFeedbacks';
              responseDataKey = 'mergedFeedback';
              break;
            case 'remittanceFeedbacks':
              actionUrl = 'fetchRemittanceFeedbacks';
              responseDataKey = 'remittanceCases';
              break;
          }
          vm.$axios
              .post(`/profile/action/${actionUrl}`, {
                repData: vm.currentData,
                filterForPartner: vm.filterForPartner
              }, {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${vm.loginData.token}`
                }
              })
              .then(async function (response) {
                switch (response.data.success) {
                  case 'true':
                    await vm.saveToIDB(response.data[responseDataKey], cardCategory, true);
                    switch (cardCategory) {
                      case 'draftProfiles':
                        vm.draftProfiles = await vm.fetchFromIDB(cardCategory);
                        break;
                      case 'unapprovedProfiles':
                        vm.unapprovedProfiles = await vm.fetchFromIDB(cardCategory);
                        break;
                      case 'approvedProfiles':
                        vm.approvedProfiles = await vm.fetchFromIDB(cardCategory);
                        break;
                      case 'returnedProfiles':
                        vm.returnedProfiles = await vm.fetchFromIDB(cardCategory);
                        break;
                      case 'rejectedProfiles':
                        vm.rejectedProfiles = await vm.fetchFromIDB(cardCategory);
                        break;
                      case 'draftFeedbacks':
                        vm.draftFeedbacks = await vm.fetchFromIDB(cardCategory);
                        break;
                      case 'unapprovedFeedbacks':
                        vm.unapprovedFeedbacks = await vm.fetchFromIDB(cardCategory);
                        break;
                      case 'returnedFeedbacks':
                        vm.returnedFeedbacks = await vm.fetchFromIDB(cardCategory);
                        break;
                      case 'closedFeedbacks':
                        vm.closedFeedbacks = await vm.fetchFromIDB(cardCategory);
                        break;
                      case 'invoiceFeedbacks':
                        vm.invoiceFeedbacks = await vm.fetchFromIDB(cardCategory);
                        break;
                      case 'remittanceFeedbacks':
                        vm.remittanceFeedbacks = await vm.fetchFromIDB(cardCategory);
                        break;
                    }
                    resolve(`${cardCategory} saved and loaded`);
                    break;
                }
              });
        } catch (loadPatientCardsError) {
          console.error(loadPatientCardsError);
          reject(`${cardCategory} failed`)
        }
      });
    },

    fetchDraftProfiles: async function () {
      let vm = this;
      vm.draftProfiles = await vm.fetchFromIDB('draftProfiles');
      vm.draftProfilesCached = true;
      return new Promise(function (resolve, reject) {
        vm.loadPatientCards('draftProfiles')
            .then(function (success) {
              vm.draftProfilesCached = false;
              resolve(success);
            }, function (fail) {
              reject(fail);
            });
      });
    },
    fetchUnapprovedProfiles: async function () {
      let vm = this;
      vm.unapprovedProfiles = await vm.fetchFromIDB('unapprovedProfiles');
      vm.unapprovedProfilesCached = true;
      return new Promise(function (resolve, reject) {
        vm.loadPatientCards('unapprovedProfiles')
            .then(function (success) {
              vm.unapprovedProfilesCached = false;
              resolve(success);
            }, function (fail) {
              reject(fail);
            });
      });
    },
    fetchApprovedProfiles: async function () {
      let vm = this;
      vm.approvedProfiles = await vm.fetchFromIDB('approvedProfiles');
      vm.approvedProfilesCached = true;
      return new Promise(function (resolve, reject) {
        vm.loadPatientCards('approvedProfiles')
            .then(function (success) {
              vm.approvedProfilesCached = false;
              resolve(success);
            }, function (fail) {
              reject(fail);
            });
      });
    },
    fetchReturnedProfiles: async function () {
      let vm = this;
      vm.returnedProfiles = await vm.fetchFromIDB('returnedProfiles');
      vm.returnedProfilesCached = true;
      return new Promise(function (resolve, reject) {
        vm.loadPatientCards('returnedProfiles')
            .then(function (success) {
              vm.returnedProfilesCached = false;
              resolve(success);
            }, function (fail) {
              reject(fail);
            });
      });
    },
    fetchRejectedProfiles: async function () {
      let vm = this;
      vm.rejectedProfiles = await vm.fetchFromIDB('rejectedProfiles');
      vm.rejectedProfilesCached = true;
      return new Promise(function (resolve, reject) {
        vm.loadPatientCards('rejectedProfiles')
            .then(function (success) {
              vm.rejectedProfilesCached = false;
              resolve(success);
            }, function (fail) {
              reject(fail);
            });
      });
    },

    fetchDraftFeedbacks: async function () {
      let vm = this;
      vm.draftFeedbacks = await vm.fetchFromIDB('draftFeedbacks');
      vm.draftFeedbacksCached = true;
      return new Promise(function (resolve, reject) {
        vm.loadPatientCards('draftFeedbacks')
            .then(function (success) {
              vm.draftFeedbacksCached = false;
              resolve(success);
            }, function (fail) {
              reject(fail);
            });
      });
    },
    fetchUnapprovedFeedbacks: async function () {
      let vm = this;
      vm.unapprovedFeedbacks = await vm.fetchFromIDB('unapprovedFeedbacks');
      vm.unapprovedFeedbacksCached = true;
      return new Promise(function (resolve, reject) {
        vm.loadPatientCards('unapprovedFeedbacks')
            .then(function (success) {
              vm.unapprovedFeedbacksCached = false;
              resolve(success);
            }, function (fail) {
              reject(fail);
            });
      });
    },
    fetchReturnedFeedbacks: async function () {
      let vm = this;
      vm.returnedFeedbacks = await vm.fetchFromIDB('returnedFeedbacks');
      vm.returnedFeedbacksCached = true;
      return new Promise(function (resolve, reject) {
        vm.loadPatientCards('returnedFeedbacks')
            .then(function (success) {
              vm.returnedFeedbacksCached = false;
              resolve(success);
            }, function (fail) {
              reject(fail);
            });
      });
    },
    fetchClosedFeedbacks: async function () {
      let vm = this;
      vm.closedFeedbacks = await vm.fetchFromIDB('closedFeedbacks');
      vm.closedFeedbacksCached = true;
      return new Promise(function (resolve, reject) {
        vm.loadPatientCards('closedFeedbacks')
            .then(function (success) {
              vm.closedFeedbacksCached = false;
              resolve(success);
            }, function (fail) {
              reject(fail);
            });
      });
    },

    fetchInvoiceFeedbacks: async function () {
      let vm = this;
      vm.invoiceFeedbacks = await vm.fetchFromIDB('invoiceFeedbacks');
      return new Promise(function (resolve, reject) {
        vm.loadPatientCards('invoiceFeedbacks')
            .then(function (success) {
              resolve(success);
            }, function (fail) {
              reject(fail);
            });
      });
    },
    fetchRemittanceFeedbacks: async function () {
      let vm = this;
      vm.remittanceFeedbacks = await vm.fetchFromIDB('remittanceFeedbacks');
      return new Promise(function (resolve, reject) {
        vm.loadPatientCards('remittanceFeedbacks')
            .then(function (success) {
              resolve(success);
            }, function (fail) {
              reject(fail);
            });
      });
    },

    fetchCardReports: function () {
      let vm = this;
      vm.$axios
          .post('/report/action/fetchAllReports', {
            repData: vm.currentData,
            filterForPartner: vm.filterForPartner
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.loginData.token}`
            }
          })
          .then(function (response) {
            switch (response.data.success) {
              case 'true':
                if (typeof response.data.reportObject !== 'undefined') {
                  vm.reportsData = {
                    reportObject: response.data.reportObject,
                    currMonth: response.data.currMonth
                  };
                } else {
                  vm.reportsData = {
                    reportObject: {},
                    currMonth: '-'
                  };
                }
                break;
            }
          })
    },
    fetchAllProfiles: function () {
      let vm = this;
      vm.$axios
          .post('/report/action/fetchAllProfiles', {
            repData: vm.currentData,
            filterForPartner: vm.filterForPartner
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.loginData.token}`
            }
          })
          .then(function (response) {
            switch (response.data.success) {
              case 'true':
                if (typeof response.data.reportObject !== 'undefined') {
                  vm.allProfilesReportsData = vm.$_.assign({}, {
                    reportObject: response.data.reportObject,
                    columnsMap: response.data.columnsMap,
                  });
                  if (isProxy(vm.allProfilesReportsData)) {
                    vm.allProfilesReportsData = toRaw(vm.allProfilesReportsData);
                  }
                  let tableData = [], columns = [];
                  vm.$_.forEach(vm.allProfilesReportsData.reportObject, function (reportObjectData) {
                    if (isProxy(reportObjectData)) {
                      tableData.push(toRaw(reportObjectData));
                    } else {
                      tableData.push(reportObjectData);
                    }
                  });
                  vm.$_.forEach(vm.allProfilesReportsData.columnsMap, function (reportColumnTitle, reportColumnName) {
                    columns.push({name: reportColumnName, data: reportColumnName, title: reportColumnTitle});
                  });
                  vm.allProfilesReportDataLoaded = true;
                  vm.allProfilesReportsDataTable = {
                    columns: columns,
                    data: tableData,
                    currentData: vm.currentData
                  };
                } else {
                  vm.allProfilesReportsData = {
                    reportObject: [],
                    columnsMap: {}
                  };
                }
                break;
            }
          })
    },
    fetchAllFeedbacks: function () {
      let vm = this;
      vm.$axios
          .post('/report/action/fetchAllFeedbacks', {
            repData: vm.currentData,
            filterForPartner: vm.filterForPartner
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.loginData.token}`
            }
          })
          .then(function (response) {
            switch (response.data.success) {
              case 'true':
                if (typeof response.data.reportObject !== 'undefined') {
                  vm.allFeedbacksReportsData = vm.$_.assign({}, {
                    reportObject: response.data.reportObject,
                    columnsMap: response.data.columnsMap,
                  });
                  if (isProxy(vm.allFeedbacksReportsData)) {
                    vm.allFeedbacksReportsData = toRaw(vm.allFeedbacksReportsData);
                  }
                  let tableData = [], columns = [];
                  vm.$_.forEach(vm.allFeedbacksReportsData.reportObject, function (reportObjectData) {
                    tableData.push(reportObjectData);
                  });
                  vm.$_.forEach(vm.allFeedbacksReportsData.columnsMap, function (reportColumnTitle, reportColumnName) {
                    columns.push({name: reportColumnName, data: reportColumnName, title: reportColumnTitle});
                  });
                  vm.allFeedbacksReportsDataLoaded = true;
                  vm.allFeedbacksReportsDataTable = {
                    columns: columns,
                    data: tableData,
                    currentData: vm.currentData
                  };
                } else {
                  vm.allFeedbacksReportsData = {
                    reportObject: [],
                    columnsMap: {}
                  };
                }
                break;
            }
          })
    },
    changeSubsectionsChoice: function (newChoice) {
      let vm = this;
      vm.subsectionsChoice = newChoice;
    },

    tableToRefresh: function (tableToRefreshObj) {
      let vm = this;
      switch (tableToRefreshObj.tableRef) {
        case 'awaitingPartnerInvoiceFinancials':
          vm.fetchInvoiceFeedbacks();
          break;
      }
    },
    updateTotalRecords: function (updateTotalRecords) {
      let vm = this;
      vm.totalTableCounts[updateTotalRecords.tableRef] = updateTotalRecords.count;
    },

    inDraftFeedbacks: async function (Identifier) {
      let vm = this;
      let draftFeedbackPatient = await vm.getPatientFromDb(vm.IDB, 'draftFeedbacks', Identifier, 'caseId', false);
      return typeof draftFeedbackPatient[0] !== 'undefined';
    },
    attachPartnerInvoice: function (caseid, p_name, f_approvalsafeaskamount, f_approvalsurgeryperformed, surgeryperformancedate, recordyear) {
      let vm = this;
      const {open: openPartnerInvoiceAttachModal, close: closePartnerInvoiceAttachModal} = useModal({
        component: vueFinalModal,
        attrs: {
          title: 'Attaching Partner Invoice',
          formFor: 'attachingPartnerInvoice',
          invoiceTableData: {
            caseid: caseid,
            p_name: p_name,
            f_approvalsafeaskamount: f_approvalsafeaskamount,
            f_approvalsurgeryperformed: f_approvalsurgeryperformed,
            surgeryperformancedate: surgeryperformancedate,
            recordyear: recordyear
          },
          clickToClose: false,
          escToClose: false,
          onCancel() {
            closePartnerInvoiceAttachModal();
          },
          onSave() {
            vm.updatePatientInvoiceRefresh = vm.$DateTime.local().setZone('utc').toUnixInteger();
            closePartnerInvoiceAttachModal();
          }
        },
        slots: {
          default: `<p>All fields are required.</p>`,
        },
      });
      openPartnerInvoiceAttachModal();
    },
    changeSurgeryPerformed: function (caseid, p_name, f_approvalsafeaskamount, f_approvalsurgeryperformed, partnerid, recordyear) {
      console.log(caseid)

      let vm = this;
      const {open: openPatientSurgeryChangeModal, close: closePatientSurgeryChangeModal} = useModal({
        component: vueFinalModal,
        attrs: {
          title: 'Changing Surgery Performed',
          formFor: 'changingSurgeryPerformed',
          surgeryTableData: {
            caseid: caseid,
            p_name: p_name,
            f_approvalsafeaskamount: f_approvalsafeaskamount,
            f_approvalsurgeryperformed: f_approvalsurgeryperformed,
            partnerid: partnerid,
            recordyear: recordyear
          },
          clickToClose: false,
          escToClose: false,
          onCancel() {
            closePatientSurgeryChangeModal();
          },
          onSave() {
            vm.updatePatientInvoiceRefresh = vm.$DateTime.local().setZone('utc').toUnixInteger();
            closePatientSurgeryChangeModal();
          }
        },
        slots: {
          default: `<p>All fields are required.</p>`,
        },
      });
      openPatientSurgeryChangeModal();

    },
    manageUserProfile: function (userid, userEmail, firstName, lastName) {
      let vm = this;
      const {open: openUserManagementModal, close: closeUserManagementModal} = useModal({
        component: vueFinalModal,
        attrs: {
          title: 'Manage User Profile',
          formFor: 'manageUserProfile',
          userIdentificationData: {
            userid: userid,
            userNames: `${firstName} ${lastName}`,
            userEmail: userEmail,
          },
          clickToClose: false,
          escToClose: false,
          onCancel() {
            closeUserManagementModal();
          },
          onSave() {
            vm.updateUserAdminRefresh = vm.$DateTime.local().setZone('utc').toUnixInteger();
            closeUserManagementModal();
          }
        },
        slots: {
          default: `<p>All fields are required.</p>`
        },
      });
      openUserManagementModal();
    },
    detachPartnerInvoice: function (caseid, invoicenumber, recordyear) {
      let vm = this;
      vm.$axios
          .post('/report/action/detachPartnerInvoice', {
            repData: vm.currentData,
            caseid: caseid,
            invoiceNumber: invoicenumber,
            recordyear: recordyear,
            formFor: `partnerInvoiceAttachment`
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.currentData.token}`
            }
          })
          .then(function (response) {
            switch (response.data.success) {
              case 'true':
                vm.updatePatientInvoiceRefresh = vm.$DateTime.local().setZone('utc').toUnixInteger();
                break;
            }
          });
    },
    approvePartnerInvoice: function (caseid, invoicenumber, approvalStatus, recordyear, partnerid) {
      let vm = this;
      vm.$axios
          .post('/report/action/approvePartnerInvoice', {
            repData: vm.currentData,
            caseid: caseid,
            invoiceNumber: invoicenumber,
            approvalStatus: approvalStatus,
            recordyear: recordyear,
            partnerid: partnerid,
            formFor: `partnerInvoiceApproval`
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.currentData.token}`
            }
          })
          .then(function (response) {
            switch (response.data.success) {
              case 'true':
                vm.updatePatientInvoiceRefresh = vm.$DateTime.local().setZone('utc').toUnixInteger();
                break;
            }
          });
    },
    setFinancialType: function (caseid, financialType, recordyear, partnerid) {
      let vm = this;
      vm.$axios
          .post('/report/action/setFinancialType', {
            repData: vm.currentData,
            caseid: caseid,
            financialType: financialType,
            recordyear: recordyear,
            partnerid: partnerid,
            formFor: `setFinancialType`
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.currentData.token}`
            }
          })
          .then(function (response) {
            switch (response.data.success) {
              case 'true':
                vm.updatePatientInvoiceRefresh = vm.$DateTime.local().setZone('utc').toUnixInteger();
                break;
            }
          });
    },
    approvePartnerReceipt: function (receiptNumber, approvalStatus, recordyear, partnerid) {
      let vm = this;

      vm.$axios
          .post('/report/action/approvePartnerReceipt', {
            repData: vm.currentData,
            receiptNumber: receiptNumber,
            approvalStatus: approvalStatus,
            recordyear: recordyear,
            partnerid: partnerid,
            formFor: `partnerReceiptApproval`
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.currentData.token}`
            }
          })
          .then(function (response) {
            switch (response.data.success) {
              case 'true':
                vm.updatePatientInvoiceRefresh = vm.$DateTime.local().setZone('utc').toUnixInteger();
                break;
            }
          });
    },
    detachAmhInvoice: function (partnerid, invoicenumber, recordyear) {
      let vm = this;

      vm.$axios
          .post('/report/action/detachAmhInvoice', {
            repData: vm.currentData,
            partnerid: partnerid,
            invoiceNumber: invoicenumber,
            recordyear: recordyear,
            formFor: `amhInvoiceAttachment`
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.currentData.token}`
            }
          })
          .then(function (response) {
            switch (response.data.success) {
              case 'true':
                vm.updatePatientInvoiceRefresh = vm.$DateTime.local().setZone('utc').toUnixInteger();
                break;
            }
          });
    },
    detachSignedInvoice: function (partnerid, invoicenumber, recordyear, caseid_list) {
      let vm = this;
      vm.$axios
          .post('/report/action/detachSignedAmhInvoice', {
            repData: vm.currentData,
            partnerid: partnerid,
            invoiceNumber: invoicenumber,
            recordyear: recordyear,
            caseidList: caseid_list,
            formFor: `signedAmhInvoiceAttachment`
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.currentData.token}`
            }
          })
          .then(function (response) {
            switch (response.data.success) {
              case 'true':
                vm.updatePatientInvoiceRefresh = vm.$DateTime.local().setZone('utc').toUnixInteger();
                break;
            }
          });
    },
    detachRemittance: function (partnerid, remittanceRef, recordyear, caseid_list) {
      let vm = this;
      vm.$axios
          .post('/report/action/detachRemittance', {
            repData: vm.currentData,
            partnerid: partnerid,
            remittanceRef: remittanceRef,
            recordyear: recordyear,
            caseidList: caseid_list,
            formFor: `amhRemittanceAttachment`
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.currentData.token}`
            }
          })
          .then(function (response) {
            switch (response.data.success) {
              case 'true':
                vm.updatePatientInvoiceRefresh = vm.$DateTime.local().setZone('utc').toUnixInteger();
                break;
            }
          });
    },
    detachReceipt: function (partnerid, receiptNumber, recordyear, caseid_list) {
      let vm = this;
      vm.$axios
          .post('/report/action/detachReceipt', {
            repData: vm.currentData,
            partnerid: partnerid,
            receiptNumber: receiptNumber,
            recordyear: recordyear,
            caseidList: caseid_list,
            formFor: `partnerReceiptApproval`
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.currentData.token}`
            }
          })
          .then(function (response) {
            switch (response.data.success) {
              case 'true':
                vm.updatePatientInvoiceRefresh = vm.$DateTime.local().setZone('utc').toUnixInteger();
                break;
            }
          });
    },
    attachSignedAmhInvoice: function (partnerid, invoicenumber, recordyear, invoiceAmount, invoicePocket, caseIdList) {
      let vm = this;
      const {open: openAmhSignedInvoiceAttachModal, close: closeAmhSignedInvoiceAttachModal} = useModal({
        component: vueFinalModal,
        attrs: {
          title: 'Attaching AMH Signed Invoice',
          formFor: 'attachingAmhInvoice',
          invoiceTableData: {
            partnerid: partnerid,
            invoicenumber: invoicenumber,
            recordyear: recordyear,
            invoiceAmount: invoiceAmount,
            invoicePocket: invoicePocket,
            caseIdList: caseIdList
          },
          clickToClose: false,
          escToClose: false,
          onCancel() {
            closeAmhSignedInvoiceAttachModal();
          },
          onSave() {
            vm.updatePatientInvoiceRefresh = vm.$DateTime.local().setZone('utc').toUnixInteger();
            closeAmhSignedInvoiceAttachModal();
          }
        },
        slots: {
          default: `<p>All fields are required.</p>`,
        },
      });
      openAmhSignedInvoiceAttachModal();
    },
    attachRemittance: function (partnerid, invoicenumber, recordyear, invoiceAmount, invoicePocket, caseIdList) {
      let vm = this;
      const {open: openRemittanceAttachModal, close: closeRemittanceAttachModal} = useModal({
        component: vueFinalModal,
        attrs: {
          title: 'Attaching Remittance',
          formFor: 'attachingRemittance',
          invoiceTableData: {
            partnerid: partnerid,
            invoicenumber: invoicenumber,
            recordyear: recordyear,
            invoiceAmount: invoiceAmount,
            invoicePocket: invoicePocket,
            caseIdList: caseIdList
          },
          clickToClose: false,
          escToClose: false,
          onCancel() {
            closeRemittanceAttachModal();
          },
          onSave() {
            vm.updatePatientInvoiceRefresh = vm.$DateTime.local().setZone('utc').toUnixInteger();
            closeRemittanceAttachModal();
          }
        },
        slots: {
          default: `<p>All fields are required.</p>`,
        },
      });
      openRemittanceAttachModal();
    },
    attachReceipt: function (partnerid, remittanceRef, recordyear, remittanceAmount, invoicePocket, caseIdList) {
      let vm = this;
      const {open: openReceiptAttachModal, close: closeReceiptAttachModal} = useModal({
        component: vueFinalModal,
        attrs: {
          title: 'Attaching Receipt',
          formFor: 'attachingReceipt',
          invoiceTableData: {
            partnerid: partnerid,
            remittanceRef: remittanceRef,
            recordyear: recordyear,
            remittanceAmount: remittanceAmount,
            invoicePocket: invoicePocket,
            caseIdList: caseIdList
          },
          clickToClose: false,
          escToClose: false,
          onCancel() {
            closeReceiptAttachModal();
          },
          onSave() {
            vm.updatePatientInvoiceRefresh = vm.$DateTime.local().setZone('utc').toUnixInteger();
            closeReceiptAttachModal();
          }
        },
        slots: {
          default: `<p>All fields are required.</p>`,
        },
      });
      openReceiptAttachModal();
    },

    updatePartnerFunds: function (parterid, partnername, currentlimit, fundfocus) {
      let vm = this;
      const {open: openFundUpdateModal, close: closeFundUpdateModal} = useModal({
        component: vueFinalModal,
        attrs: {
          title: 'Updating Fund Allocation',
          formFor: 'updatingFundsAllocation',
          fundsUpdatingData: {
            parterid: parterid,
            partnername: partnername,
            currentlimit: currentlimit,
            fundfocus: fundfocus
          },
          clickToClose: false,
          escToClose: false,
          onCancel() {
            closeFundUpdateModal();
          },
          onSave() {
            vm.updateFundAllocationRefresh = vm.$DateTime.local().setZone('utc').toUnixInteger();
            closeFundUpdateModal();
          }
        },
        slots: {
          default: `<p>All fields are required.</p>`,
        },
      });
      openFundUpdateModal();
    },

    activatePartner: function (partnerid) {
      let vm = this;
      vm.$axios
          .post('/admin/action/activatePartner', {partnerid: partnerid, coordData: vm.currentData}, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.loginData.token}`
            }
          })
          .then(async function () {
            console.log('reload')


          });

    },
    fetchPartner: function (partnerid) {
      const {open: openPartnerEditModal, close: closePartnerEditModal} = useModal({
        component: vueFinalModal,
        attrs: {
          title: 'Edit SAFE Partner',
          formFor: 'safePartnerForm',
          partnerSelectData: {
            partnerid: partnerid
          },
          clickToClose: false,
          escToClose: false,
          onCancel() {
            closePartnerEditModal();
          },
          onSave() {
            closePartnerEditModal();
          }
        },
        slots: {
          default: `<p>All fields are required.</p>`,
        },
      });
      openPartnerEditModal();

    },
    allowUser: function (userid, allowScope) {
      let vm = this;
      vm.$axios
          .post('/admin/action/allowUser', {userid: userid, scope: allowScope, coordData: vm.currentData}, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${vm.loginData.token}`
            }
          })
          .then(async function () {
            console.log('reload')
            vm.updateUserAdminRefresh = vm.$DateTime.local().setZone('utc').toUnixInteger();
          });

    },
  },
  computed: {
    liSubsectionsView() {
      let vm = this;
      if (vm.tabsView === 'Search') {
        return `${vm.tabsView}`;
      } else {
        return `${vm.subsectionsChoice} ${vm.tabsView}`;
      }
    },
    noCasesView() {
      let vm = this,
          returnValue = true;
      switch (vm.tabsView) {
        case 'Financials':
          returnValue = false;
          break;
        case 'Reports':
          returnValue = false;
          break;
        case 'Admin':
          returnValue = false;
          break;
        case 'Funds':
          returnValue = false;
          break;
        case 'Cases':
          returnValue = false;
          break;
        default:
          break;
      }
      return returnValue;
    },
    countsObj() {
      let vm = this,
          countsObjFilled = {
            allProfiles: 0,
            draftProfiles: vm.draftProfiles.length,
            submittedProfiles: vm.unapprovedProfiles.length,
            approvedProfiles: vm.approvedProfiles.length,
            returnedProfiles: vm.returnedProfiles.length,
            rejectedProfiles: vm.rejectedProfiles.length,
            allFeedbacks: 0,
            draftFeedbacks: vm.draftFeedbacks.length,
            submittedFeedbacks: vm.unapprovedFeedbacks.length,
            returnedFeedbacks: vm.returnedFeedbacks.length,
            closedFeedbacks: vm.closedFeedbacks.length,
            awaitingPartnerInvoiceFinancials: vm.awaitingPartnerInvoiceFinancialsCount,
            awaitingPartnerRemittanceFinancials: vm.awaitingPartnerRemittanceFinancialsCount,
          }

      countsObjFilled.allProfiles = countsObjFilled.submittedProfiles +
          countsObjFilled.approvedProfiles +
          countsObjFilled.returnedProfiles +
          countsObjFilled.rejectedProfiles;

      if (vm.loginData.role === 'Representative') {
        countsObjFilled.allProfiles += countsObjFilled.draftProfiles;
      }

      countsObjFilled.allFeedbacks = countsObjFilled.draftFeedbacks +
          countsObjFilled.submittedFeedbacks +
          countsObjFilled.returnedFeedbacks +
          countsObjFilled.closedFeedbacks;

      if (vm.loginData.role === 'Representative') {
        countsObjFilled.allFeedbacks += countsObjFilled.draftFeedbacks;
      }


      return countsObjFilled;
    },

    caseViews: function () {
      let vm = this,
          returnView,
          emergencyCasesCount = vm.categoryCounts.emergencyCases,
          electiveCasesCount = vm.categoryCounts.electiveCases;
      if (!vm.caseViewSelected) {
        if (parseInt(emergencyCasesCount) === 0) {
          if (parseInt(electiveCasesCount) > 0) {
            returnView = 'Elective'
          } else {
            returnView = 'No Cases';
          }
        } else {
          returnView = 'Emergency'
        }
      } else {
        returnView = vm.caseViewSelected
      }
      return returnView;
    },

    categoryCounts: function () {
      let vm = this;
      switch (`${vm.subsectionsChoice} ${vm.tabsView}`) {
        case 'Submitted Profiles':
          return vm.unapprovedProfileCounts;
        case 'Re-submitted Profiles':
          return vm.unapprovedProfileCounts;
        case 'Approved Profiles':
          return vm.approvedProfileCounts;
        case 'Returned Profiles':
          return vm.returnedProfileCounts;
        case 'Rejected Profiles':
          return vm.rejectedProfileCounts;
        case 'Submitted Feedbacks':
          return vm.submittedFeedbackCounts;
        case 'Re-submitted Feedbacks':
          return vm.submittedFeedbackCounts;
        case 'Returned Feedbacks':
          return vm.returnedFeedbackCounts;
        case 'Pulled Feedbacks':
          return vm.closedFeedbackCounts;
        default:
          return {emergencyCases: 0, electiveCases: 0};
      }
    },
    filteredUnapprovedProfiles: function () {
      let vm = this,
          filteredProfiles = [],
          filteredProfilesCounts = {emergencyCases: 0, electiveCases: 0};
      vm.$_.forEach(vm.unapprovedProfiles, function (typeOfProfile) {
        if (typeOfProfile.surgeryType === vm.caseViews) {
          filteredProfiles.push(typeOfProfile);
        }
        if (typeOfProfile.surgeryType === 'Emergency') {
          filteredProfilesCounts.emergencyCases++;
        }
        if (typeOfProfile.surgeryType === 'Elective') {
          filteredProfilesCounts.electiveCases++;
        }
      });
      vm.unapprovedProfileCounts = filteredProfilesCounts;
      return filteredProfiles;
    },
    filteredApprovedProfiles: function () {
      let vm = this,
          filteredProfiles = [],
          filteredProfilesCounts = {emergencyCases: 0, electiveCases: 0};
      vm.$_.forEach(vm.approvedProfiles, function (typeOfProfile) {
        if (typeOfProfile.surgeryType === vm.caseViews) {
          filteredProfiles.push(typeOfProfile);
        }
        if (typeOfProfile.surgeryType === 'Emergency') {
          filteredProfilesCounts.emergencyCases++;
        }
        if (typeOfProfile.surgeryType === 'Elective') {
          filteredProfilesCounts.electiveCases++;
        }
      });
      vm.approvedProfileCounts = filteredProfilesCounts;
      return filteredProfiles;
    },
    filteredReturnedProfiles: function () {
      let vm = this,
          filteredProfiles = [],
          filteredProfilesCounts = {emergencyCases: 0, electiveCases: 0};
      vm.$_.forEach(vm.returnedProfiles, function (typeOfProfile) {
        if (typeOfProfile.surgeryType === vm.caseViews) {
          filteredProfiles.push(typeOfProfile);
        }
        if (typeOfProfile.surgeryType === 'Emergency') {
          filteredProfilesCounts.emergencyCases++;
        }
        if (typeOfProfile.surgeryType === 'Elective') {
          filteredProfilesCounts.electiveCases++;
        }
      });
      vm.returnedProfileCounts = filteredProfilesCounts;
      return filteredProfiles;
    },
    filteredRejectedProfiles: function () {
      let vm = this,
          filteredProfiles = [],
          filteredProfilesCounts = {emergencyCases: 0, electiveCases: 0};
      vm.$_.forEach(vm.rejectedProfiles, function (typeOfProfile) {
        if (typeOfProfile.surgeryType === vm.caseViews) {
          filteredProfiles.push(typeOfProfile);
        }
        if (typeOfProfile.surgeryType === 'Emergency') {
          filteredProfilesCounts.emergencyCases++;
        }
        if (typeOfProfile.surgeryType === 'Elective') {
          filteredProfilesCounts.electiveCases++;
        }
      });
      vm.rejectedProfileCounts = filteredProfilesCounts;
      return filteredProfiles;
    },
    filteredUnapprovedFeedbacks: function () {
      let vm = this,
          filteredProfiles = [],
          filteredProfilesCounts = {emergencyCases: 0, electiveCases: 0};
      vm.$_.forEach(vm.unapprovedFeedbacks, function (typeOfProfile) {
        if (typeOfProfile.profile.surgeryType === vm.caseViews) {
          filteredProfiles.push(typeOfProfile);
        }
        if (typeOfProfile.profile.surgeryType === 'Emergency') {
          filteredProfilesCounts.emergencyCases++;
        }
        if (typeOfProfile.profile.surgeryType === 'Elective') {
          filteredProfilesCounts.electiveCases++;
        }
      });
      vm.submittedFeedbackCounts = filteredProfilesCounts;
      return filteredProfiles;
    },
    filteredReturnedFeedbacks: function () {
      let vm = this,
          filteredProfiles = [],
          filteredProfilesCounts = {emergencyCases: 0, electiveCases: 0};
      vm.$_.forEach(vm.returnedFeedbacks, function (typeOfProfile) {
        if (typeOfProfile.profile.surgeryType === vm.caseViews) {
          filteredProfiles.push(typeOfProfile);
        }
        if (typeOfProfile.profile.surgeryType === 'Emergency') {
          filteredProfilesCounts.emergencyCases++;
        }
        if (typeOfProfile.profile.surgeryType === 'Elective') {
          filteredProfilesCounts.electiveCases++;
        }
      });
      vm.returnedFeedbackCounts = filteredProfilesCounts;
      return filteredProfiles;
    },
    filteredClosedFeedbacks: function () {
      let vm = this,
          filteredProfiles = [],
          filteredProfilesCounts = {emergencyCases: 0, electiveCases: 0};
      vm.$_.forEach(vm.closedFeedbacks, function (typeOfProfile) {
        if (typeOfProfile.profile.surgeryType === vm.caseViews) {
          filteredProfiles.push(typeOfProfile);
        }
        if (typeOfProfile.profile.surgeryType === 'Emergency') {
          filteredProfilesCounts.emergencyCases++;
        }
        if (typeOfProfile.profile.surgeryType === 'Elective') {
          filteredProfilesCounts.electiveCases++;
        }
      });
      vm.closedFeedbackCounts = filteredProfilesCounts;
      return filteredProfiles;
    },

    awaitingPartnerInvoiceFinancials() {
      let vm = this,
          columns = [
            {
              name: 'caseid', data: 'caseid', title: 'Case ID', render: function (data, type, row) {
                return `<a class="button is-success is-light" href="/caseview/${data}/financecase/${row.partnerid}/${row.recordyear}" target="_blank"><span>${data}</span> <span class="icon is-small"><i class="fas fa-arrow-up-right-from-square"></i></span></a>`;
              }
            },
            {name: 'p_name', data: 'p_name', title: 'Patient Name'},
            {name: 'p_inpatientnumber', data: 'p_inpatientnumber', title: 'in-patient Number'},
            {name: 'p_approvalpocket', data: 'p_approvalpocket', title: 'Fund Pocket'},
            {name: 'p_watsiid', data: 'p_watsiid', title: 'Watsi ID'},
            {name: 'f_approvalsafeaskamount', data: 'f_approvalsafeaskamount', title: 'Safe Ask (USD)'},
            {
              name: 'f_approvalsurgeryperformed',
              data: 'f_approvalsurgeryperformed',
              title: 'Surgery Performed',
              render: function (data, type, row) {
                if (vm.loginData.role === 'Coordinator') {
                  return `<div>
                            <div>${data}</div>
                            <div>
                                <button class="button is-info is-small" style="border-radius: 10px;" onclick="changeSurgeryPerformed('${row.caseid}','${row.p_name}','${row.f_approvalsafeaskamount}','${row.f_approvalsurgeryperformed}','${row.partnerid}','${row.recordyear}')"><span class="icon is-small"><i class="fas fa-retweet"></i></span></button>
                            </div>
                          </div>`;
                } else {
                  return data;
                }
              }
            },
            {name: 'f_surgeryfrom', data: 'f_surgeryfrom', title: 'Surgery From'},
            {name: 'profileapprovaldate', data: 'profileapprovaldate', title: 'Profile Approval Date'},
            {name: 'surgeryperformancedate', data: 'surgeryperformancedate', title: 'Surgery Date'},
          ],
          tableData = [];
      if (vm.loginData.role === 'Coordinator') {
        columns.push({name: 'partnername', data: 'partnername', title: 'Partner'});
      }

      if (vm.loginData.role === 'Representative') {
        columns.push({
          name: 'prt_inv_number',
          data: 'prt_inv_number',
          title: 'Invoice',
          render: function (data, type, row) {
            return `<button class="button is-info" onclick="attachPartnerInvoice('${row.caseid}','${vm.strictUrlEncode(row.p_name)}','${row.f_approvalsafeaskamount}','${row.f_approvalsurgeryperformed}','${row.surgeryperformancedate}','${row.recordyear}')"><span>Attach</span> <span class="icon is-small"><i class="fas fa-file-invoice-dollar"></i></span></button>`;
          }
        });
      }

      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    attachedPartnerInvoiceFinancials() {
      let vm = this,
          columns = [
            {
              name: 'caseid', data: 'caseid', title: 'Case ID', render: function (data, type, row) {
                return `<a class="button is-success is-light" href="/caseview/${data}/financecase/${row.partnerid}/${row.recordyear}" target="_blank"><span>${data}</span> <span class="icon is-small"><i class="fas fa-arrow-up-right-from-square"></i></span></a>`;
              }
            },
            {name: 'p_name', data: 'p_name', title: 'Patient Name'},
            {name: 'p_inpatientnumber', data: 'p_inpatientnumber', title: 'in-patient Number'},
            {name: 'p_approvalpocket', data: 'p_approvalpocket', title: 'Fund Pocket'},
            {name: 'p_watsiid', data: 'p_watsiid', title: 'Watsi ID'},
            {name: 'f_approvalsafeaskamount', data: 'f_approvalsafeaskamount', title: 'Safe Ask (USD)'},
            // {name: 'f_approvalsurgeryperformed', data: 'f_approvalsurgeryperformed', title: 'Surgery Performed'},
            {
              name: 'f_approvalsurgeryperformed',
              data: 'f_approvalsurgeryperformed',
              title: 'Surgery Performed',
              render: function (data, type, row) {
                if (vm.loginData.role === 'Coordinator') {
                  return `<div>
                            <div>${data}</div>
                            <div>
                                <button class="button is-info is-small" style="border-radius: 10px;" onclick="changeSurgeryPerformed('${row.caseid}','${row.p_name}','${row.f_approvalsafeaskamount}','${row.f_approvalsurgeryperformed}','${row.partnerid}','${row.recordyear}')"><span class="icon is-small"><i class="fas fa-retweet"></i></span></button>
                            </div>
                          </div>`;
                } else {
                  return data;
                }
              }
            },
            {name: 'f_surgeryfrom', data: 'f_surgeryfrom', title: 'Surgery From'},
            {name: 'profileapprovaldate', data: 'profileapprovaldate', title: 'Profile Approval Date'},
            {name: 'surgeryperformancedate', data: 'surgeryperformancedate', title: 'Surgery Date'},
            {
              name: 'prt_inv_number', data: 'prt_inv_number', title: 'Invoice Number',
              render: function (data, type, row) {
                if (row.download_url !== null) {
                  return `<div>
                            <div>${data}</div>
                            <div>
                                <a class="button is-link is-small" style="border-radius: 10px;" href="${row.download_url}"><span class="icon is-small"><i class="fas fa-download"></i></span></a>
                            </div>
                          </div>`;
                } else {
                  return `${data}`;
                }
              }
            },
            {name: 'prt_inv_date', data: 'prt_inv_date', title: 'Invoice Date'},
            {
              name: 'prt_inv_amount',
              data: 'prt_inv_amount',
              title: 'Invoice Amount',
              render: function (data, type, row) {
                return `${row.prt_inv_currency} ${data}`;
              }
            }
          ],
          tableData = [];
      if (vm.loginData.role === 'Coordinator') {
        columns.push({name: 'partnername', data: 'partnername', title: 'Partner'});
        columns.push({
          name: 'prt_inv_approved',
          data: 'prt_inv_approved',
          title: 'Approve Invoice',
          render: function (data, type, row) {
            if (!data) {
              return `<button class="button is-success" onclick="approvePartnerInvoice('${row.caseid}','${row.prt_inv_number}','approve','${row.recordyear}','${row.partnerid}')"><span>Approve</span> <span class="icon is-small"><i class="fas fa-check"></i></span></button>`;
            } else {
              return `<button class="button is-danger" onclick="approvePartnerInvoice('${row.caseid}','${row.prt_inv_number}','reject','${row.recordyear}','${row.partnerid}')"><span>Reject</span> <span class="icon is-small"><i class="fas fa-times"></i></span></button>`;
            }
          }
        });
      }

      if (vm.loginData.role === 'Representative') {
        columns.push({
          name: 'prt_inv_approved',
          data: 'prt_inv_approved',
          title: 'Approve Invoice',
          render: function (data) {
            if (data) {
              return `Approved`;
            } else {
              return `Not Approved`;
            }
          }
        });
        columns.push({
          name: 'prt_inv_number',
          data: 'prt_inv_number',
          title: 'Detach Invoice',
          render: function (data, type, row) {
            return `<button class="button is-danger" onclick="detachPartnerInvoice('${row.caseid}','${row.prt_inv_number}','${row.recordyear}')"><span>Detach</span> <span class="icon is-small"><i class="fas fa-xmark"></i></span></button>`;
          }
        });
      }
      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    sentAmhInvoiceFinancials() {
      let vm = this,
          columns = [
            {name: 'p_approvalpocket', data: 'p_approvalpocket', title: 'Fund Pocket'},
            {
              name: 'amh_inv_number', data: 'amh_inv_number', title: 'Invoice Number',
              render: function (data, type, row) {
                return `<div>
                            <div>${data}</div>
                            <div>
                                <a class="button is-link is-small" style="border-radius: 10px;" href="${row.download_url}"><span class="icon is-small"><i class="fas fa-download"></i></span></a>
                            </div>
                          </div>`;
                // return `<a class="button is-link" href="${row.download_url}"><span>${data}</span> <span class="icon is-small"><i class="fas fa-download"></i></span></a>`;
              }
            },
            {name: 'amh_inv_date', data: 'amh_inv_date', title: 'Invoice Date'},
            {
              name: 'amh_inv_amount',
              data: 'amh_inv_amount',
              title: 'Invoice Amount',
              render: function (data, type, row) {
                return `${row.amh_inv_currency} ${data}`;
              }
            }
          ],
          tableData = [];
      if (vm.loginData.role === 'Coordinator') {
        columns.push({name: 'partnername', data: 'partnername', title: 'Partner'},
            {
              name: 'amh_inv_number',
              data: 'amh_inv_number',
              title: 'Detach Invoice',
              render: function (data, type, row) {
                return `<button class="button is-danger" onclick="detachAmhInvoice('${row.partnerid}','${data}','${row.recordyear}')"><span>Detach</span> <span class="icon is-small"><i class="fas fa-xmark"></i></span></button>`;
              }
            });
      }

      if (vm.loginData.role === 'Representative') {
        columns.push({
              name: 'amh_inv_number',
              data: 'amh_inv_number',
              title: 'Attach Signed Invoice',
              render: function (data, type, row) {
                return `<button class="button is-info" onclick="attachSignedAmhInvoice('${row.partnerid}','${data}','${row.recordyear}','${row.amh_inv_currency} ${row.amh_inv_amount}','${row.p_approvalpocket}','${row.caseid_list}')"><span>Attach</span> <span class="icon is-small"><i class="fas fa-file-signature"></i></span></button>`;
              }
            },
            {
              name: 'amh_inv_number',
              data: 'amh_inv_number',
              title: 'Detach Invoice',
              render: function (data, type, row) {
                return `<button class="button is-danger" onclick="detachAmhInvoice('${row.partnerid}','${data}','${row.recordyear}')"><span>Detach</span> <span class="icon is-small"><i class="fas fa-xmark"></i></span></button>`;
              }
            });
      }
      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    awaitingAmhRemittanceFinancials() {
      let vm = this,
          columns = [
            {name: 'p_approvalpocket', data: 'p_approvalpocket', title: 'Fund Pocket'},
            {
              name: 'amh_inv_number', data: 'amh_inv_number', title: 'Invoice Number',
              render: function (data, type, row) {
                return `<div>
                            <div>${data}</div>
                            <div>
                                <a class="button is-link is-small" style="border-radius: 10px;" href="${row.unsigned_download_url}"><span class="icon is-small"><i class="fas fa-download"></i></span></a>
                            </div>
                          </div>`;
                // return `<a class="button is-link" href="${row.unsigned_download_url}"><span>${data}</span> <span class="icon is-small"><i class="fas fa-download"></i></span></a>`;
              }
            },
            {
              name: 'amh_inv_amount',
              data: 'amh_inv_amount',
              title: 'Invoice Amount',
              render: function (data, type, row) {
                return `${row.amh_inv_currency} ${data}`;
              }
            },
            {
              name: 'amh_inv_number', data: 'amh_inv_number', title: 'Signed Invoice',
              render: function (data, type, row) {
                return `<div>
                            <div>${data}</div>
                            <div>
                                <a class="button is-link is-small" style="border-radius: 10px;" href="${row.signed_download_url}"><span class="icon is-small"><i class="fas fa-download"></i></span></a>
                            </div>
                          </div>`;
                // return `<a class="button is-link" href="${row.signed_download_url}"><span class="icon is-small"><i class="fas fa-download"></i></span></a>`;
              }
            },
          ],
          tableData = [];
      if (vm.loginData.role === 'Coordinator') {
        columns.push({name: 'partnername', data: 'partnername', title: 'Partner'},
            {
              name: 'amh_inv_number',
              data: 'amh_inv_number',
              title: 'Attach Remittance',
              render: function (data, type, row) {
                return `<button class="button is-info" onclick="attachRemittance('${row.partnerid}','${data}','${row.recordyear}','${row.amh_inv_currency} ${row.amh_inv_amount}', '${row.p_approvalpocket}','${row.caseid_list}')"><span>Attach</span> <span class="icon is-small"><i class="fas fa-file-invoice-dollar"></i></span></button>`;
              }
            });
      }

      if (vm.loginData.role === 'Representative') {
        columns.push({
          name: 'amh_inv_number',
          data: 'amh_inv_number',
          title: 'Detach Signed Invoice',
          render: function (data, type, row) {
            return `<button class="button is-danger" onclick="detachSignedInvoice('${row.partnerid}','${data}','${row.recordyear}','${row.caseid_list}')"><span>Detach</span> <span class="icon is-small"><i class="fas fa-xmark"></i></span></button>`;
          }
        });
      }
      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    awaitingPartnerReceiptFinancials() {
      let vm = this,
          columns = [
            {name: 'p_approvalpocket', data: 'p_approvalpocket', title: 'Fund Pocket'},
            {
              name: 'amh_inv_number', data: 'amh_inv_number', title: 'Invoice Number',
              render: function (data, type, row) {
                return `<div>
                            <div>${data}</div>
                            <div>
                                <a class="button is-link is-small" style="border-radius: 10px;" href="${row.signed_download_url}"><span class="icon is-small"><i class="fas fa-download"></i></span></a>
                            </div>
                          </div>`;
                // return `<a class="button is-link" href="${row.signed_download_url}"><span>${data}</span><span class="icon is-small"><i class="fas fa-download"></i></span></a>`;
              }
            },
            {
              name: 'rem_amount',
              data: 'rem_amount',
              title: 'Remittance Amount',
              render: function (data, type, row) {
                return `${row.rem_currency} ${data}`;
              }
            },
            {
              name: 'rem_trans_ref', data: 'rem_trans_ref', title: 'Remittance',
              render: function (data, type, row) {
                return `<div>
                            <div>${data}</div>
                            <div>
                                <a class="button is-link is-small" style="border-radius: 10px;" href="${row.remittance_download_url}"><span class="icon is-small"><i class="fas fa-download"></i></span></a>
                            </div>
                          </div>`;
                // return `<a class="button is-link" href="${row.remittance_download_url}"><span>${data}</span><span class="icon is-small"><i class="fas fa-download"></i></span></a>`;
              }
            },
          ],
          tableData = [];
      if (vm.loginData.role === 'Coordinator') {
        columns.push({name: 'partnername', data: 'partnername', title: 'Partner'});
        columns.push({
          name: 'rem_trans_ref',
          data: 'rem_trans_ref',
          title: 'Detach Remittance',
          render: function (data, type, row) {
            return `<button class="button is-danger" onclick="detachRemittance('${row.partnerid}','${data}','${row.recordyear}','${row.caseid_list}')"><span>Detach</span> <span class="icon is-small"><i class="fas fa-xmark"></i></span></button>`;
          }
        });


      }

      if (vm.loginData.role === 'Representative') {
        columns.push({
          name: 'rem_trans_ref',
          data: 'rem_trans_ref',
          title: 'Attach Receipt',
          render: function (data, type, row) {
            return `<button class="button is-info" onclick="attachReceipt('${row.partnerid}','${data}','${row.recordyear}','${row.rem_currency} ${row.rem_amount}', '${row.p_approvalpocket}','${row.caseid_list}')"><span>Attach</span> <span class="icon is-small"><i class="fas fa-file-invoice-dollar"></i></span></button>`;
          }
        });
      }
      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    receivedPartnerReceiptFinancials() {
      let vm = this,
          columns = [
            {name: 'p_approvalpocket', data: 'p_approvalpocket', title: 'Fund Pocket'},
            {
              name: 'amh_inv_number', data: 'amh_inv_number', title: 'Invoice Number',
              render: function (data, type, row) {
                return `<div>
                            <div>${data}</div>
                            <div>
                                <a class="button is-link is-small" style="border-radius: 10px;" href="${row.signed_download_url}"><span class="icon is-small"><i class="fas fa-download"></i></span></a>
                            </div>
                          </div>`;
                // return `<a class="button is-link" href="${row.signed_download_url}"><span>${data}</span><span class="icon is-small"><i class="fas fa-download"></i></span></a>`;
              }
            },
            {
              name: 'rem_trans_ref', data: 'rem_trans_ref', title: 'Remittance',
              render: function (data, type, row) {
                return `<div>
                            <div>${data}</div>
                            <div>
                                <a class="button is-link is-small" style="border-radius: 10px;" href="${row.remittance_download_url}"><span class="icon is-small"><i class="fas fa-download"></i></span></a>
                            </div>
                          </div>`;
                // return `<a class="button is-link" href="${row.remittance_download_url}"><span>${data}</span><span class="icon is-small"><i class="fas fa-download"></i></span></a>`;
              }
            },
            {
              name: 'rct_number', data: 'rct_number', title: 'Receipt Number',
              render: function (data, type, row) {
                return `<div>
                            <div>${data}</div>
                            <div>
                                <a class="button is-link is-small" style="border-radius: 10px;" href="${row.receipt_download_url}"><span class="icon is-small"><i class="fas fa-download"></i></span></a>
                            </div>
                          </div>`;
                // return `<a class="button is-link" href="${row.receipt_download_url}"><span>${data}</span><span class="icon is-small"><i class="fas fa-download"></i></span></a>`;
              }
            },
            {
              name: 'rct_amount',
              data: 'rct_amount',
              title: 'Receipt Amount',
              render: function (data, type, row) {
                return `${row.rct_currency} ${data}`;
              }
            },
          ],
          tableData = [];
      if (vm.loginData.role === 'Coordinator') {
        columns.push({name: 'partnername', data: 'partnername', title: 'Partner'});
        columns.push({
          name: 'rct_verified',
          data: 'rct_verified',
          title: 'Receipt Status',
          render: function (data, type, row) {
            let approveButton = `<button class="button is-success" onclick="approvePartnerReceipt('${row.rct_number}','approve','${row.recordyear}','${row.partnerid}')"><span>Approve</span> <span class="icon is-small"><i class="fas fa-check"></i></span></button>`;
            let rejectButton = `<button class="button is-danger" onclick="approvePartnerReceipt('${row.rct_number}','reject','${row.recordyear}','${row.partnerid}')"><span>Reject</span> <span class="icon is-small"><i class="fas fa-times"></i></span></button>`;
            return `<div class="buttons has-addons is-centered">${approveButton}${rejectButton}</div>`;
          }
        });

      }

      if (vm.loginData.role === 'Representative') {
        columns.push({
          name: 'rct_verified',
          data: 'rct_verified',
          title: 'Receipt Status',
          render: function (data, type, row) {
            if (data) {
              return `<span class="tag is-success">Verified</span>`;
            } else {
              return `<button class="button is-info" onclick="detachReceipt('${row.partnerid}','${row.rct_number}','${row.recordyear}','${row.caseid_list}')"><span>Detach</span> <span class="icon is-small"><i class="fas fa-xmark"></i></span></button>`;
            }
          }
        });
      }
      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    completedFinancials() {
      let vm = this,
          columns = [
            {name: 'p_approvalpocket', data: 'p_approvalpocket', title: 'Fund Pocket'},
            {
              name: 'amh_inv_number', data: 'amh_inv_number', title: 'Invoice Number',
              render: function (data, type, row) {
                return `<div>
                            <div>${data}</div>
                            <div>
                                <a class="button is-link is-small" style="border-radius: 10px;" href="${row.signed_download_url}"><span class="icon is-small"><i class="fas fa-download"></i></span></a>
                            </div>
                          </div>`;
                // return `<a class="button is-link" href="${row.signed_download_url}"><span>${data}</span><span class="icon is-small"><i class="fas fa-download"></i></span></a>`;
              }
            },
            {
              name: 'rem_trans_ref', data: 'rem_trans_ref', title: 'Remittance',
              render: function (data, type, row) {
                return `<div>
                            <div>${data}</div>
                            <div>
                                <a class="button is-link is-small" style="border-radius: 10px;" href="${row.remittance_download_url}"><span class="icon is-small"><i class="fas fa-download"></i></span></a>
                            </div>
                          </div>`;
                // return `<a class="button is-link" href="${row.remittance_download_url}"><span>${data}</span><span class="icon is-small"><i class="fas fa-download"></i></span></a>`;
              }
            },
            {
              name: 'rct_number', data: 'rct_number', title: 'Receipt Number',
              render: function (data, type, row) {
                return `<div>
                            <div>${data}</div>
                            <div>
                                <a class="button is-link is-small" style="border-radius: 10px;" href="${row.receipt_download_url}"><span class="icon is-small"><i class="fas fa-download"></i></span></a>
                            </div>
                          </div>`;
                // return `<a class="button is-link" href="${row.receipt_download_url}"><span>${data}</span><span class="icon is-small"><i class="fas fa-download"></i></span></a>`;
              }
            },
            {
              name: 'rct_amount',
              data: 'rct_amount',
              title: 'Receipt Amount',
              render: function (data, type, row) {
                return `${row.rct_currency} ${data}`;
              }
            },
            {
              name: 'rct_verified',
              data: 'rct_verified',
              title: 'Receipt Status',
              render: function () {
                return `Verified`;
              }
            }
          ],
          tableData = [];
      if (vm.loginData.role === 'Coordinator') {
        columns.push({name: 'partnername', data: 'partnername', title: 'Partner'});
      }
      return {columns: columns, data: tableData, currentData: vm.currentData};
    },

    profileSubmissionReportData() {
      let vm = this,
          columns = [
            {name: 'monthYear', data: 'monthYear', title: 'Period'},
            {name: 'profilesubmitted', data: 'profilesubmitted', title: 'Profile Submitted'},
            {name: 'profileapproved', data: 'profileapproved', title: 'Profile Approved'},
            {name: 'profilereturned', data: 'profilereturned', title: 'Profile Returned'},
            {name: 'profilerejected', data: 'profilerejected', title: 'Profile Rejected'},
            {name: 'feedbacksubmitted', data: 'feedbacksubmitted', title: 'Feedback Submitted'},
            {name: 'feedbackreturned', data: 'feedbackreturned', title: 'Feedback Returned'},
            {name: 'feedbackclosed', data: 'feedbackclosed', title: 'Feedback Closed'},
            {name: 'feedbackinvoice', data: 'feedbackinvoice', title: 'Feedback Awaiting Invoice'},
            {name: 'feedbackremitance', data: 'feedbackremitance', title: 'Feedback Awaiting Remittance'}
          ],
          rowDataByPocket = {},
          tableData = [];
      if (vm.loginData.role === 'Coordinator') {
        columns.push({name: 'PartnerName', data: 'PartnerName', title: 'Partner'});
      }

      let workingPartnerName = '';

      if (vm.reportsData.currMonth !== '-') {
        vm.$_.forEach(vm.reportsData.reportObject, function (reportObjectData, reportObjectDataPartner) {
          if (vm.loginData.role === 'Coordinator') {
            vm.$_.forEach(vm.loginData.partners, function (partner) {
              if (parseInt(partner.partnerid) === parseInt(reportObjectDataPartner)) {
                workingPartnerName = partner.partner_name
              }
            });
          }

          vm.$_.forEach(reportObjectData, function (reportObjectDataData, reportObjectDataPeriod) {
            if (reportObjectDataPeriod !== '0000_00') {
              rowDataByPocket = {
                monthYear: vm.$DateTime.fromFormat(reportObjectDataPeriod, 'yyyy_LL').toUTC().toFormat("LLL - yyyy"),
                profilesubmitted: reportObjectDataData.profilesubmitted.count,
                profileapproved: reportObjectDataData.profileapproved.count,
                profilereturned: reportObjectDataData.profilereturned.count,
                profilerejected: reportObjectDataData.profilerejected.count,
                feedbacksubmitted: reportObjectDataData.feedbacksubmitted.count,
                feedbackreturned: reportObjectDataData.feedbackreturned.count,
                feedbackclosed: reportObjectDataData.feedbackclosed.count,
                feedbackinvoice: reportObjectDataData.feedbackinvoice.count,
                feedbackremitance: reportObjectDataData.feedbackremitance.count,
              };
              if (vm.loginData.role === 'Coordinator') {
                rowDataByPocket.PartnerName = workingPartnerName;
              }
              vm.$_.forEach(columns, function (column) {
                if (typeof rowDataByPocket[column.name] === 'undefined') {
                  rowDataByPocket[column.name] = '-';
                }
              });
              tableData.push(rowDataByPocket);
            }
          });
        });
      }

      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    fundsUtilizationReportData() {
      let vm = this,
          columns = [
            {name: 'monthYear', data: 'monthYear', title: 'Period'},
            {name: 'watsi', data: 'watsi', title: 'Watsi'},
            {name: 'amhEcs', data: 'amhEcs', title: 'AMH ECS'},
            {name: 'amhSvd', data: 'amhSvd', title: 'AMH SVD'},
            {name: 'amhOther', data: 'amhOther', title: 'AMH Other'},
            {name: 'totalUtil', data: 'totalUtil', title: 'Total Utilization'}
          ],
          rowDataByPocket = {},
          tableData = [];
      if (vm.loginData.role === 'Coordinator') {
        columns.push({name: 'PartnerName', data: 'PartnerName', title: 'Partner'});
        columns.push({name: 'amhContingency', data: 'amhContingency', title: 'AMH Contingency'});
      }

      let workingPartnerName = '';

      if (vm.reportsData.currMonth !== '-') {
        vm.$_.forEach(vm.reportsData.reportObject, function (reportObjectData, reportObjectDataPartner) {
          if (vm.loginData.role === 'Coordinator') {
            vm.$_.forEach(vm.loginData.partners, function (partner) {
              if (parseInt(partner.partnerid) === parseInt(reportObjectDataPartner)) {
                workingPartnerName = partner.partner_name
              }
            });
          }

          vm.$_.forEach(reportObjectData, function (reportObjectDataData, reportObjectDataPeriod) {
            if (reportObjectDataPeriod !== '0000_00') {
              try {
                rowDataByPocket = {
                  monthYear: vm.$DateTime.fromFormat(reportObjectDataPeriod, 'yyyy_LL').toUTC().toFormat("LLL - yyyy"),
                  watsi: reportObjectDataData.pockets.Watsi.value,
                  amhEcs: reportObjectDataData.pockets['AMH ECS'].value,
                  amhSvd: reportObjectDataData.pockets['AMH SVD'].value,
                  amhOther: reportObjectDataData.pockets['AMH Other'].value,
                  totalUtil: reportObjectDataData.pockets['Aggregate'].value,
                };
              } catch (e) {
                console.log(e);
                console.log(reportObjectDataPeriod);
                console.log(reportObjectDataData);
              }

              if (vm.loginData.role === 'Coordinator') {
                rowDataByPocket.PartnerName = workingPartnerName;
                rowDataByPocket.amhContingency = reportObjectDataData.pockets['AMH Contingency'].value;
              }
              tableData.push(rowDataByPocket);
            }

          });
        });
      }

      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    openStageReports() {
      let vm = this,
          columns = [
            // {
            //   name: 'caseid', data: 'caseid', title: 'Case ID', render: function (data, type, row) {
            //     return `<a class="button is-success is-light" href="/caseview/${data}/opencase/${row.partnerid}/${row.recordyear}" target="_blank"><span>${data}</span> <span class="icon is-small"><i class="fas fa-arrow-up-right-from-square"></i></span></a>`;
            //   }
            // },
            {name: 'caseid', data: 'caseid', title: 'Case ID'},
            {name: 'case_stage', data: 'case_stage', title: 'Case Stage'},
            {name: 'p_name', data: 'p_name', title: 'Patient Name'},
            {name: 'p_safeaskamount', data: 'p_safeaskamount', title: 'Safe Ask (USD)'},
            {name: 'p_approvalpocket', data: 'p_approvalpocket', title: 'Fund Pocket'},
            {name: 'watsiid', data: 'watsiid', title: 'Watsi ID'},
            {name: 'p_surgeryrequired', data: 'p_surgeryrequired', title: 'Surgery Required (Profile)'},
            {name: 'profileapprovaldate', data: 'profileapprovaldate', title: 'Profile Approval Date'},
            {name: 'surgeryperformancedate', data: 'surgeryperformancedate', title: 'Surgery Date'},
          ],
          tableData = [];
      if (vm.loginData.role === 'Coordinator') {
        columns.push({name: 'partnername', data: 'partnername', title: 'Partner'});
      }

      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    rejectedStageReports() {
      let vm = this,
          columns = [
            {
              name: 'caseid', data: 'caseid', title: 'Case ID', render: function (data, type, row) {
                return `<a class="button is-success is-light" href="/caseview/${data}/financecase/${row.partnerid}/${row.recordyear}" target="_blank"><span>${data}</span> <span class="icon is-small"><i class="fas fa-arrow-up-right-from-square"></i></span></a>`;
              }
            },
            {name: 'p_name', data: 'p_name', title: 'Patient Name'},
            {name: 'f_approvalsafeaskamount', data: 'f_approvalsafeaskamount', title: 'Safe Ask (USD)'},
            {name: 'f_approvalsurgeryperformed', data: 'f_approvalsurgeryperformed', title: 'Surgery Performed'},
            {name: 'f_surgeryfrom', data: 'f_surgeryfrom', title: 'Surgery From'},
            {name: 'profileapprovaldate', data: 'profileapprovaldate', title: 'Profile Rejection Date'},
          ],
          tableData = [];
      if (vm.loginData.role === 'Coordinator') {
        columns.push({name: 'partnername', data: 'partnername', title: 'Partner'});
      }

      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    pulledStageReports() {
      let vm = this,
          columns = [
            {
              name: 'caseid', data: 'caseid', title: 'Case ID', render: function (data, type, row) {
                return `<a class="button is-success is-light" href="/caseview/${data}/financecase/${row.partnerid}/${row.recordyear}" target="_blank"><span>${data}</span> <span class="icon is-small"><i class="fas fa-arrow-up-right-from-square"></i></span></a>`;
              }
            },
            {name: 'p_name', data: 'p_name', title: 'Patient Name'},
            {name: 'f_approvalsafeaskamount', data: 'f_approvalsafeaskamount', title: 'Safe Ask (USD)'},
            {name: 'f_approvalsurgeryperformed', data: 'f_approvalsurgeryperformed', title: 'Surgery Performed'},
            {name: 'f_surgeryfrom', data: 'f_surgeryfrom', title: 'Surgery From'},
            {name: 'profileapprovaldate', data: 'profileapprovaldate', title: 'Feedback Pulling Date'},
          ],
          tableData = [];
      if (vm.loginData.role === 'Coordinator') {
        columns.push({name: 'partnername', data: 'partnername', title: 'Partner'});
      }

      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    cancelledStageReports() {
      let vm = this,
          columns = [
            {
              name: 'caseid', data: 'caseid', title: 'Case ID', render: function (data, type, row) {
                return `<a class="button is-success is-light" href="/caseview/${data}/financecase/${row.partnerid}/${row.recordyear}" target="_blank"><span>${data}</span> <span class="icon is-small"><i class="fas fa-arrow-up-right-from-square"></i></span></a>`;
              }
            },
            {name: 'p_name', data: 'p_name', title: 'Patient Name'},
            {name: 'f_approvalsafeaskamount', data: 'f_approvalsafeaskamount', title: 'Safe Ask (USD)'},
            {name: 'f_approvalsurgeryperformed', data: 'f_approvalsurgeryperformed', title: 'Surgery Performed'},
            {name: 'f_surgeryfrom', data: 'f_surgeryfrom', title: 'Surgery From'},
            {name: 'profileapprovaldate', data: 'profileapprovaldate', title: 'Feedback Cancelling Date'},
          ],
          tableData = [];
      if (vm.loginData.role === 'Coordinator') {
        columns.push({name: 'partnername', data: 'partnername', title: 'Partner'});
      }

      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    closedStageReports() {
      let vm = this,
          columns = [
            {
              name: 'caseid', data: 'caseid', title: 'Case ID', render: function (data, type, row) {
                return `<a class="button is-success is-light" href="/caseview/${data}/financecase/${row.partnerid}/${row.recordyear}" target="_blank"><span>${data}</span> <span class="icon is-small"><i class="fas fa-arrow-up-right-from-square"></i></span></a>`;
              }
            },
            {name: 'p_name', data: 'p_name', title: 'Patient Name'},
            {name: 'f_approvalsafeaskamount', data: 'f_approvalsafeaskamount', title: 'Safe Ask (USD)'},
            {name: 'f_approvalsurgeryperformed', data: 'f_approvalsurgeryperformed', title: 'Surgery Performed'},
            {name: 'f_surgeryfrom', data: 'f_surgeryfrom', title: 'Surgery From'},
            {name: 'profileapprovaldate', data: 'profileapprovaldate', title: 'Feedback Closing Date'},
          ],
          tableData = [];
      if (vm.loginData.role === 'Coordinator') {
        columns.push({name: 'partnername', data: 'partnername', title: 'Partner'});
      }

      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    invoiceStageReports() {
      let vm = this,
          columns = [
            {
              name: 'caseid', data: 'caseid', title: 'Case ID', render: function (data, type, row) {
                return `<a class="button is-success is-light" href="/caseview/${data}/financecase/${row.partnerid}/${row.recordyear}" target="_blank"><span>${data}</span> <span class="icon is-small"><i class="fas fa-arrow-up-right-from-square"></i></span></a>`;
              }
            },
            {name: 'p_name', data: 'p_name', title: 'Patient Name'},
            {name: 'p_approvalpocket', data: 'p_approvalpocket', title: 'Fund Pocket'},
            {name: 'watsiid', data: 'watsiid', title: 'Watsi ID'},
            {name: 'f_approvalsafeaskamount', data: 'f_approvalsafeaskamount', title: 'Safe Ask (USD)'},
            {name: 'f_approvalsurgeryperformed', data: 'f_approvalsurgeryperformed', title: 'Surgery Performed'},
            {name: 'f_surgeryfrom', data: 'f_surgeryfrom', title: 'Surgery From'},
            {name: 'profileapprovaldate', data: 'profileapprovaldate', title: 'Profile Approval Date'},
            {name: 'surgeryperformancedate', data: 'surgeryperformancedate', title: 'Surgery Date'},
            {
              name: 'finance_through_app',
              data: 'finance_through_app',
              title: 'Financials Type',
              render: function (data, type, row) {
                if (row.amh_inv_number === '-') {
                  if (!data) {
                    return `<button class="button is-success" onclick="setFinancialType('${row.caseid}','throughapp','${row.recordyear}','${row.partnerid}')"><span>Pay Through App</span> <span class="icon is-small"><i class="fas fa-check"></i></span></button>`;
                  } else {
                    return `<button class="button is-danger" onclick="setFinancialType('${row.caseid}','outsideapp','${row.recordyear}','${row.partnerid}')"><span>Pay Outside App</span> <span class="icon is-small"><i class="fas fa-times"></i></span></button>`;
                  }
                } else {
                  return `<span>AMH Invoice: ${row.amh_inv_number}</span>`;
                }
              }
            },
          ],
          tableData = [];
      if (vm.loginData.role === 'Coordinator') {
        columns.push({name: 'partnername', data: 'partnername', title: 'Partner'});
      }

      return {columns: columns, data: tableData, currentData: vm.currentData};
    },

    partnersAdmin() {
      let vm = this,
          columns = [
            {name: 'partnerid', data: 'partnerid', title: 'ID'},
            {
              name: 'partner_name', data: 'partner_name', title: 'Name', render: function (data, type, row) {
                return `<button class="button is-info" onclick="fetchPartner('${row.partnerid}')"><span>${row.partner_name}</span></button>`;
              }
            },
            {name: 'partner_shortname', data: 'partner_shortname', title: 'Short Name'},
            {
              name: 'partner_active', data: 'partner_active', title: 'Status', render: function (data, type, row) {
                if (data === 1) {
                  return `<button class="button is-danger is-light" onclick="activatePartner('${row.partnerid}')"><span>Deactivate</span> <span class="icon is-small"><i class="fas fa-house-medical-circle-xmark"></i></span></button>`;
                } else {
                  return `<button class="button is-success is-light" onclick="activatePartner('${row.partnerid}')"><span>Activate</span> <span class="icon is-small"><i class="fas fa-house-medical-circle-check"></i></span></button>`;
                }
              }
            },
            // {name: 'partner_description', data: 'partner_description', title: 'Description'},
            // {name: 'partner_location', data: 'partner_location', title: 'Location'},
            {name: 'partner_email', data: 'partner_email', title: 'Email'},
            {name: 'coordinator_cc_email', data: 'coordinator_cc_email', title: 'Sponsor Email'},
          ],
          tableData = [];
      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    usersAdmin() {
      let vm = this,
          columns = [
            // {name: 'userid', data: 'userid', title: 'ID'},
            {name: 'first_name', data: 'first_name', title: 'First Name'},
            {name: 'last_name', data: 'last_name', title: 'Last Name'},
            {
              name: 'email', data: 'email', title: 'Email', render: function (data, type, row) {
                return `<button class="button is-info" onclick="manageUserProfile('${row.userid}','${row.email}','${row.first_name}','${row.last_name}')"><span>${row.email}</span> <span class="icon is-small"><i class="fas fa-id-badge"></i></span></button>`;
              }
            },
            {
              name: 'approved', data: 'approved', title: 'Access', render: function (data, type, row) {
                if (parseInt(vm.currentData.uid) === parseInt(row.userid)) {
                  if (data === 1) {
                    return `Allowed`;
                  } else {
                    return `Denied`;
                  }
                } else {
                  if (data === 1) {
                    return `<button class="button is-danger is-light" onclick="allowUser('${row.userid}','Access')"><span>Deny</span> <span class="icon is-small"><i class="fas fa-user-slash"></i></span></button>`;
                  } else {
                    return `<button class="button is-success is-light"  onclick="allowUser('${row.userid}','Access')"><span>Allow</span> <span class="icon is-small"><i class="fas fa-user"></i></span></button>`;
                  }
                }
              }
            },
            // {name: 'partner', data: 'partner', title: 'Partner'},
            // {name: 'role', data: 'role', title: 'Role'},
            {
              name: 'fundmanage', data: 'fundmanage', title: 'Fund Manager', render: function (data, type, row) {
                if (row.approved === 1) {
                  if (parseInt(vm.currentData.uid) === parseInt(row.userid)) {
                    if (data === 1) {
                      return `Granted`;
                    } else {
                      return `Denied`;
                    }
                  } else {
                    if (data === 1) {
                      return `<button class="button is-danger is-light" onclick="allowUser('${row.userid}','FundManager')"><span>Deny</span> <span class="icon is-small"><i class="fas fa-user-slash"></i></span></button>`;
                    } else {
                      return `<button class="button is-success is-light" onclick="allowUser('${row.userid}','FundManager')"><span>Grant</span> <span class="icon is-small"><i class="fas fa-user"></i></span></button>`;
                    }
                  }
                } else {
                  return `Denied`;
                }
              }
            },
            {
              name: 'adminrole', data: 'adminrole', title: 'Admin Rights', render: function (data, type, row) {
                if (row.approved === 1) {
                  if (parseInt(vm.currentData.uid) === parseInt(row.userid)) {
                    if (data === 1) {
                      return `Granted`;
                    } else {
                      return `Denied`;
                    }
                  } else {
                    if (data === 1) {
                      return `<button class="button is-danger is-light" onclick="allowUser('${row.userid}','Admin')"><span>Deny</span> <span class="icon is-small"><i class="fas fa-user-slash"></i></span></button>`;
                    } else {
                      return `<button class="button is-success is-light" onclick="allowUser('${row.userid}','Admin')"><span>Grant</span> <span class="icon is-small"><i class="fas fa-user"></i></span></button>`;
                    }
                  }
                } else {
                  return `Denied`;
                }
              }
            },
          ],
          tableData = [];
      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    preapprovalsAdmin() {
      let vm = this,
          columns = [
            // {name: 'preapprovalid', data: 'preapprovalid', title: 'ID'},
            {name: 'surgery', data: 'surgery', title: 'Surgery'},
            // {name: 'surgery_category', data: 'surgery_category', title: 'Surgery Category'},
            {name: 'surgery_subcategory', data: 'surgery_subcategory', title: 'Surgery Subcategory'},
            {name: 'cost', data: 'cost', title: 'Cost'},
            {name: 'with_pi_fee', data: 'with_pi_fee', title: 'Cost with PI'},
            {name: 'currency', data: 'currency', title: 'Cost Currency'},
            // {name: 'parity_ind', data: 'parity_ind', title: 'Parity Required'},
            // {name: 'gravidity_ind', data: 'gravidity_ind', title: 'Gravidity Required'},
            // {name: 'feedback_children_count', data: 'feedback_children_count', title: 'Birth Outcome Required'},
            {
              name: 'emergency_ind', data: 'emergency_ind', title: 'Emergency', render: function (data) {
                if (data === 1) {
                  return 'Yes';
                } else {
                  return 'No';
                }
              }
            },
            // {name: 'time_required', data: 'time_required', title: 'Time Required'},
            // {name: 'admission_required', data: 'admission_required', title: 'Admission Time Required'},
            // {name: 'surgery_required', data: 'surgery_required', title: 'Surgery Time Required'},
            // {name: 'discharge_required', data: 'discharge_required', title: 'Discharge Time Required'},
            // {name: 'decisiontime_required', data: 'decisiontime_required', title: 'Decision Time Required'},
          ],
          tableData = [];
      return {columns: columns, data: tableData, currentData: vm.currentData};
    },

    PocketFundsWatsi() {
      let vm = this,
          columns = [
            {name: 'partnerid', data: 'partnerid', title: 'ID'},
            {name: 'partner_name', data: 'partner_name', title: 'Name'},
            {name: 'partner_shortname', data: 'partner_shortname', title: 'Short Name'},
            {
              name: 'partner_active', data: 'partner_active', title: 'Status', render: function (data) {
                if (data === 1) {
                  return `Active`;
                } else {
                  return `Deactivated`;
                }
              }
            },
            {
              name: 'fund_watsi', data: 'fund_watsi', title: 'Allocation (USD)', render: function (data) {
                return vm.$formatNumber({
                  prefix: ``,
                  round: 2,
                  integerSeparator: ','
                })(data, {noSeparator: false})
              }
            },
            {
              name: 'partnerid', data: 'partnerid', title: 'Update', render: function (data, type, row) {
                return `<button class="button is-info" onclick="updatePartnerFunds('${row.partnerid}','${row.partner_name}','${row.fund_watsi}','Watsi')"><span>Update</span> <span class="icon is-small"><i class="fas fa-pen-nib"></i></span></button>`;
              }
            }


          ],
          tableData = [];
      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    PocketFundsContingency() {
      let vm = this,
          columns = [
            {name: 'partnerid', data: 'partnerid', title: 'ID'},
            {name: 'partner_name', data: 'partner_name', title: 'Name'},
            {name: 'partner_shortname', data: 'partner_shortname', title: 'Short Name'},
            {
              name: 'partner_active', data: 'partner_active', title: 'Status', render: function (data) {
                if (data === 1) {
                  return `Active`;
                } else {
                  return `Deactivated`;
                }
              }
            },
            {
              name: 'fund_contingencyfund',
              data: 'fund_contingencyfund',
              title: 'Allocation (USD)',
              render: function (data) {
                return vm.$formatNumber({
                  prefix: ``,
                  round: 2,
                  integerSeparator: ','
                })(data, {noSeparator: false})
              }
            },
            {
              name: 'partnerid', data: 'partnerid', title: 'Update', render: function (data, type, row) {
                return `<button class="button is-info" onclick="updatePartnerFunds('${row.partnerid}','${row.partner_name}','${row.fund_contingencyfund}','AMH Contingency')"><span>Update</span> <span class="icon is-small"><i class="fas fa-pen-nib"></i></span></button>`;
              }
            }
          ],
          tableData = [];
      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    PocketFundsEcs() {
      let vm = this,
          columns = [
            {name: 'partnerid', data: 'partnerid', title: 'ID'},
            {name: 'partner_name', data: 'partner_name', title: 'Name'},
            {name: 'partner_shortname', data: 'partner_shortname', title: 'Short Name'},
            {
              name: 'partner_active', data: 'partner_active', title: 'Status', render: function (data) {
                if (data === 1) {
                  return `Active`;
                } else {
                  return `Deactivated`;
                }
              }
            },
            {
              name: 'fund_amhecs', data: 'fund_amhecs', title: 'Allocation (USD)', render: function (data) {
                return vm.$formatNumber({
                  prefix: ``,
                  round: 2,
                  integerSeparator: ','
                })(data, {noSeparator: false})
              }
            },
            {
              name: 'partnerid', data: 'partnerid', title: 'Update', render: function (data, type, row) {
                return `<button class="button is-info" onclick="updatePartnerFunds('${row.partnerid}','${row.partner_name}','${row.fund_amhecs}','AMH ECS')"><span>Update</span> <span class="icon is-small"><i class="fas fa-pen-nib"></i></span></button>`;
              }
            }
          ],
          tableData = [];
      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    PocketFundsSvd() {
      let vm = this,
          columns = [
            {name: 'partnerid', data: 'partnerid', title: 'ID'},
            {name: 'partner_name', data: 'partner_name', title: 'Name'},
            {name: 'partner_shortname', data: 'partner_shortname', title: 'Short Name'},
            {
              name: 'partner_active', data: 'partner_active', title: 'Status', render: function (data) {
                if (data === 1) {
                  return `Active`;
                } else {
                  return `Deactivated`;
                }
              }
            },
            {
              name: 'fund_amhsvd', data: 'fund_amhsvd', title: 'Allocation (USD)', render: function (data) {
                return vm.$formatNumber({
                  prefix: ``,
                  round: 2,
                  integerSeparator: ','
                })(data, {noSeparator: false})
              }
            },
            {
              name: 'partnerid', data: 'partnerid', title: 'Update', render: function (data, type, row) {
                return `<button class="button is-info" onclick="updatePartnerFunds('${row.partnerid}','${row.partner_name}','${row.fund_amhsvd}','AMH SVD')"><span>Update</span> <span class="icon is-small"><i class="fas fa-pen-nib"></i></span></button>`;
              }
            }
          ],
          tableData = [];
      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    PocketFundsOther() {
      let vm = this,
          columns = [
            {name: 'partnerid', data: 'partnerid', title: 'ID'},
            {name: 'partner_name', data: 'partner_name', title: 'Name'},
            {name: 'partner_shortname', data: 'partner_shortname', title: 'Short Name'},
            {
              name: 'partner_active', data: 'partner_active', title: 'Status', render: function (data) {
                if (data === 1) {
                  return `Active`;
                } else {
                  return `Deactivated`;
                }
              }
            },
            {
              name: 'fund_amhother', data: 'fund_amhother', title: 'Allocation (USD)', render: function (data) {
                return vm.$formatNumber({
                  prefix: ``,
                  round: 2,
                  integerSeparator: ','
                })(data, {noSeparator: false})
              }
            },
            {
              name: 'partnerid', data: 'partnerid', title: 'Update', render: function (data, type, row) {
                return `<button class="button is-info" onclick="updatePartnerFunds('${row.partnerid}','${row.partner_name}','${row.fund_amhother}','AMH Other')"><span>Update</span> <span class="icon is-small"><i class="fas fa-pen-nib"></i></span></button>`;
              }
            }
          ],
          tableData = [];
      return {columns: columns, data: tableData, currentData: vm.currentData};
    },

    ActiveDataCases() {
      let vm = this,
          columns = [
            {
              name: 'caseid', data: 'caseid', title: 'ID', render: function (data, type, row) {
                return `<a class="button is-success is-light" href="/caseview/${data}/activecase/${row.partnerid}/0" target="_blank"><span>${data}</span> <span class="icon is-small"><i class="fas fa-arrow-up-right-from-square"></i></span></a>`;
              }
            },
            {name: 'patient_name', data: 'patient_name', title: 'Patient'},
            {
              name: 'has_profile', data: 'has_profile', title: 'Profile', render: function (data) {
                if (data === 'Yes') {
                  return `<span class="icon is-small"><i class="fas fa-check"></i></span>`;
                } else {
                  return `<span class="icon is-small"><i class="fas fa-x"></i></span>`;
                }
              }
            },
            {
              name: 'has_profile_approval',
              data: 'has_profile_approval',
              title: 'Profile Approval',
              render: function (data, type, row) {
                if (data === 'Yes') {
                  let returnicon = '-';
                  switch (row.profile_approval_color) {
                    case 'green':
                      returnicon = `<span class="icon is-small" style="color: ${row.profile_approval_color};"><i class="fas fa-check"></i></span>`
                      break;
                    case 'blue':
                      returnicon = `<span class="icon is-small" style="color: ${row.profile_approval_color};"><i class="fas fa-rotate-left"></i></span>`
                      break;
                    case 'red':
                      returnicon = `<span class="icon is-small" style="color: ${row.profile_approval_color};"><i class="fas fa-x"></i></span>`
                      break;
                  }
                  return returnicon;
                } else {
                  return `<span class="icon is-small"><i class="fas fa-x"></i></span>`;
                }
              }
            },
            {
              name: 'has_feedback', data: 'has_feedback', title: 'Feedback', render: function (data) {
                if (data === 'Yes') {
                  return `<span class="icon is-small"><i class="fas fa-check"></i></span>`;
                } else {
                  return `<span class="icon is-small"><i class="fas fa-x"></i></span>`;
                }
              }
            },
            {
              name: 'has_feedback_approval',
              data: 'has_feedback_approval',
              title: 'Feedback Approval',
              render: function (data, type, row) {
                if (data === 'Yes') {
                  let returnicon = '-';
                  switch (row.feedback_approval_color) {
                    case 'green':
                      returnicon = `<span class="icon is-small" style="color: ${row.feedback_approval_color};"><i class="fas fa-check"></i></span>`
                      break;
                    case 'blue':
                      returnicon = `<span class="icon is-small" style="color: ${row.feedback_approval_color};"><i class="fas fa-rotate-left"></i></span>`
                      break;
                    case 'red':
                      returnicon = `<span class="icon is-small" style="color: ${row.feedback_approval_color};"><i class="fas fa-x"></i></span>`
                      break;
                  }
                  return returnicon;
                } else {
                  return `<span class="icon is-small"><i class="fas fa-x"></i></span>`;
                }
              }
            },
            {
              name: 'CaseFlagReason',
              data: 'CaseFlagReason',
              title: 'Case Details',
              render: function (data, type, row) {
                if (row.CaseFlag === 'red') {
                  return `<span style="color: red">${data}</span>`;
                } else {
                  return `<span style="color: ${row.caseStageColor}">${row.caseStageDetails}</span>`;
                }
              }
            },
          ],

          tableData = [];
      return {columns: columns, data: tableData, currentData: vm.currentData};
    },

    topCardNumbers() {
      let vm = this,
          workingMonth,
          returnedData = {
            submitted: 0,
            approved: 0,
            utilized: 0,
            available: 0
          }, returnedDataAccount = {
            submitted: 0,
            approved: 0,
            utilized: 0,
            available: 0
          };

      try {
        switch (vm.loginData.role) {
          case 'Representative':
            if (vm.reportsData.currMonth !== '-') {
              if (typeof vm.reportsData.reportObject[vm.loginData.partnerid] !== 'undefined') {
                returnedData.available = vm.reportsData.reportObject[vm.loginData.partnerid]['0000_00'].totalAllocated;
                if (typeof vm.reportsData.reportObject[vm.loginData.partnerid][vm.reportsData.currMonth] !== 'undefined') {
                  workingMonth = vm.reportsData.reportObject[vm.loginData.partnerid][vm.reportsData.currMonth];
                  returnedData = vm.$_.assignIn({}, returnedData, {
                    submitted: workingMonth.profilesubmitted.count + workingMonth.profileapproved.count,
                    approved: workingMonth.profileapproved.count,
                    utilized: vm.$shortNumber(workingMonth.pockets.Aggregate.value),
                    available: vm.$shortNumber(returnedData.available - workingMonth.pockets.Aggregate.value)
                  });
                }
              }
            }
            break;
          case 'Coordinator':
            if (vm.reportsData.currMonth !== '-') {
              vm.$_.forEach(vm.reportsData.reportObject, function (partnerReport) {
                returnedDataAccount = {
                  submitted: 0,
                  approved: 0,
                  utilized: 0,
                  available: 0
                };
                returnedDataAccount.available = partnerReport['0000_00'].totalAllocated;
                if (typeof partnerReport[vm.reportsData.currMonth] !== 'undefined') {
                  workingMonth = partnerReport[vm.reportsData.currMonth];
                  returnedDataAccount = vm.$_.assignIn({}, returnedDataAccount, {
                    submitted: workingMonth.profilesubmitted.count + workingMonth.profileapproved.count,
                    approved: workingMonth.profileapproved.count,
                    utilized: workingMonth.pockets.Aggregate.value,
                    available: returnedDataAccount.available - workingMonth.pockets.Aggregate.value
                  });
                }
                returnedData = vm.$_.assignIn({}, returnedData, {
                  submitted: returnedData.submitted + returnedDataAccount.submitted,
                  approved: returnedData.approved + returnedDataAccount.approved,
                  utilized: returnedData.utilized + returnedDataAccount.utilized,
                  available: returnedData.available + returnedDataAccount.available
                });
              });
              returnedData = vm.$_.assignIn({}, returnedData, {
                submitted: vm.$shortNumber(returnedData.submitted),
                approved: vm.$shortNumber(returnedData.approved),
                utilized: vm.$shortNumber(returnedData.utilized),
                available: vm.$shortNumber(returnedData.available)
              });
            }
            break;
        }
      } catch (topCardError) {
        console.error(topCardError)
      }

      return returnedData;
    },
    allProfilesReportData() {
      let vm = this,
          columns = [],
          tableData = [];

      vm.$_.forEach(vm.allProfilesReportsData.reportObject, function (reportObjectData) {
        tableData.push(reportObjectData);
      });
      vm.$_.forEach(vm.allProfilesReportsData.columnsMap, function (reportColumnTitle, reportColumnName) {
        columns.push({name: reportColumnName, data: reportColumnName, title: reportColumnTitle});
      });
      vm.allProfilesReportDataLoaded = true;
      return {
        columns: columns,
        data: tableData,
        currentData: vm.currentData
      };
    },
    showTablesToolbar: function () {
      let vm = this;
      if (vm.tabsView === 'Financials' || vm.tabsView === 'Reports') {

        return !(vm.loginData.role === 'Representative' && vm.subsectionsChoice === 'Generate AMH Invoice');
      } else {
        return false;
      }
    },
    showPaidUnpaidChecks: function () {
      let vm = this;
      return vm.tabsView === 'Reports' && vm.subsectionsChoice === 'Finance';
    }
  },
  async mounted() {
    let vm = this;

    vm.IDB = await vm.getIDB()

    const tabsViewSaved = localStorage.getItem("tabsView");
    if (tabsViewSaved) {
      vm.tabsView = tabsViewSaved;
    } else {
      vm.tabsView = 'Profiles'
    }

    const subsectionsChoiceSaved = localStorage.getItem("subsectionsChoice");
    if (subsectionsChoiceSaved) {
      vm.subsectionsChoice = subsectionsChoiceSaved;
    } else {
      vm.subsectionsChoice = 'Submitted'
    }

    const filterForPartnerSaved = localStorage.getItem("filterForPartner");
    if (filterForPartnerSaved) {
      vm.filterForPartner = filterForPartnerSaved;
    } else {
      vm.filterForPartner = 'all'
    }

    const storedAccount = localStorage.getItem("account");
    vm.currentData = JSON.parse(storedAccount);

    switch (vm.loginData.role) {
      case 'Representative':
        vm.fetchDraftProfiles()
            .then(vm.fetchUnapprovedProfiles())
            .then(vm.fetchApprovedProfiles())
            .then(vm.fetchReturnedProfiles())
            .then(vm.fetchRejectedProfiles())

        vm.fetchDraftFeedbacks()
            .then(vm.fetchUnapprovedFeedbacks())
            .then(vm.fetchReturnedFeedbacks())
            .then(vm.fetchClosedFeedbacks());

        vm.fetchInvoiceFeedbacks()
            .then(vm.fetchRemittanceFeedbacks());

        vm.fetchCardReports();
        vm.fetchAllProfiles();
        vm.fetchAllFeedbacks();
        break;
      case 'Coordinator':
        vm.fetchUnapprovedProfiles()
            .then(vm.fetchApprovedProfiles())
            .then(vm.fetchReturnedProfiles())
            .then(vm.fetchRejectedProfiles())

        vm.fetchUnapprovedFeedbacks()
            .then(vm.fetchReturnedFeedbacks())
            .then(vm.fetchClosedFeedbacks());

        vm.fetchInvoiceFeedbacks()
            .then(vm.fetchRemittanceFeedbacks());

        vm.fetchCardReports();
        vm.fetchAllProfiles();
        vm.fetchAllFeedbacks();
        break;
    }

    vm.homePageVarsLoaded = true;
  },
  watch: {
    reloadCases: {
      async handler() {
        let vm = this;
        vm.$_.forEach(vm.reloadCases.casesIn, function (reloadCaseIn) {
          switch (reloadCaseIn) {
            case 'draftProfiles':
              vm.fetchDraftProfiles();
              break;
            case 'returnedProfiles':
              vm.fetchReturnedProfiles();
              break;
          }
        });
      },
      deep: true
    },
    filterForPartner: {
      async handler(newValue, oldValue) {
        let vm = this;
        localStorage.setItem("filterForPartner", vm.filterForPartner);
        if (!(newValue === 'all' && oldValue === '')) {
          vm.$emit('filterForPartner', vm.filterForPartner);

          switch (vm.loginData.role) {
            case 'Representative':
              vm.fetchDraftProfiles()
                  .then(vm.fetchUnapprovedProfiles())
                  .then(vm.fetchApprovedProfiles())
                  .then(vm.fetchReturnedProfiles())
                  .then(vm.fetchRejectedProfiles());

              vm.fetchDraftFeedbacks()
                  .then(vm.fetchUnapprovedFeedbacks())
                  .then(vm.fetchReturnedFeedbacks())
                  .then(vm.fetchClosedFeedbacks());
              break;
            case 'Coordinator':
              vm.fetchUnapprovedProfiles()
                  .then(vm.fetchApprovedProfiles())
                  .then(vm.fetchReturnedProfiles())
                  .then(vm.fetchRejectedProfiles());

              vm.fetchUnapprovedFeedbacks()
                  .then(vm.fetchReturnedFeedbacks())
                  .then(vm.fetchClosedFeedbacks());

              break;
          }

          vm.fetchInvoiceFeedbacks()
              .then(vm.fetchRemittanceFeedbacks());

          vm.fetchCardReports();
          vm.fetchAllProfiles();
          vm.fetchAllFeedbacks();

          vm.drawTime = vm.$DateTime.local().setZone('utc').toUnixInteger();
        }
      },
      deep: true
    },
    tabsView: {
      handler() {
        let vm = this;
        localStorage.setItem("tabsView", vm.tabsView);
      },
      deep: true
    },
    subsectionsChoice: {
      handler() {
        let vm = this;
        localStorage.setItem("subsectionsChoice", vm.subsectionsChoice);
      },
      deep: true
    },
    searchResults: {
      handler(newValue, oldValue) {
        let vm = this;
        if (newValue.length > 0 && oldValue.length === 0) {
          vm.tabsView = 'Search'
        }
      },
      deep: true
    }
  },
  created() {
    let vm = this;
    window.attachPartnerInvoice = vm.attachPartnerInvoice;
    window.detachPartnerInvoice = vm.detachPartnerInvoice;
    window.approvePartnerInvoice = vm.approvePartnerInvoice;
    window.setFinancialType = vm.setFinancialType;
    window.detachAmhInvoice = vm.detachAmhInvoice;
    window.attachSignedAmhInvoice = vm.attachSignedAmhInvoice;
    window.detachSignedInvoice = vm.detachSignedInvoice;
    window.attachRemittance = vm.attachRemittance;
    window.detachRemittance = vm.detachRemittance;
    window.attachReceipt = vm.attachReceipt;
    window.approvePartnerReceipt = vm.approvePartnerReceipt;
    window.detachReceipt = vm.detachReceipt;
    window.updatePartnerFunds = vm.updatePartnerFunds;
    window.allowUser = vm.allowUser;
    window.activatePartner = vm.activatePartner;
    window.fetchPartner = vm.fetchPartner;
    window.manageUserProfile = vm.manageUserProfile;
    window.changeSurgeryPerformed = vm.changeSurgeryPerformed;
  }
};
</script>

<template>
  <ol style="--length: 10" role="list" class="items-list">
    <li class="items-list card-list amh-card AMH-darkGray">
      <div class="card">
        <div class="card-content user-card">
          <div class="media user-card-media">
            <div class="media-left">
              <figure class="image is-128x128">
                <img v-bind:src="`${placeholdersBaseUrl}/profile/placeholder/${loginData.partnerid}.png`"
                     alt="Med Rep" class="image is-128x128" v-if="loginData.role==='Representative'">
                <img v-bind:src="`${placeholdersBaseUrl}/profile/placeholder/0.png`"
                     alt="Med Rep" class="image is-128x128" v-if="loginData.role==='Coordinator'">
              </figure>
            </div>
            <div class="media-content">
              <p class="items-list title is-4">{{ loginData.fname }} {{ loginData.lname }}</p>
              <p class="items-list subtitle is-6 no-margin-p">{{ loginData.role }}</p>
              <p class="items-list subtitle is-6" v-if="loginData.role==='Representative'">{{ loginData.partner }}</p>
              <div class="items-list subtitle is-6" v-if="loginData.role==='Coordinator'">
                <div class="tag is-hoverable is-primary is-light partner-tags"
                     v-for="(partner, index) in loginData.partners" v-bind:key="index">
                  {{ partner.partner_name }}
                </div>
              </div>
            </div>
          </div>
          <div class="content">
            <nav class="level is-mobile">
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Submitted</p>
                  <p class="title" v-html="topCardNumbers.submitted"></p>
                </div>
              </div>
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Approved</p>
                  <p class="title" v-html="topCardNumbers.approved"></p>
                </div>
              </div>
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Utilized</p>
                  <p class="title" v-html="topCardNumbers.utilized"></p>
                </div>
              </div>
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Available</p>
                  <p class="title" v-html="topCardNumbers.available"></p>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </li>

    <li v-if="loginData.role==='Coordinator'">
      <div class="select is-rounded is-fullwidth partner-select">
        <select v-model="filterForPartner">
          <option value="all">All Partners</option>
          <option v-bind:value="partner.partnerid" v-for="(partner, index) in loginData.partners" v-bind:key="index">
            {{ partner.partner_name }}
          </option>
        </select>
      </div>
    </li>

    <li>
      <div class="tabs is-boxed amh-top-tabs">
        <ul>
          <li v-bind:class="{'is-active':tabsView==='Profiles'}"
              v-on:click="tabsView = 'Profiles'">
            <a>Profiles
              <span class="item-counts">{{ countsObj.allProfiles }}</span>
            </a>
          </li>
          <li v-bind:class="{'is-active':tabsView==='Feedbacks'}"
              v-on:click="tabsView = 'Feedbacks'">
            <a>Feedbacks
              <span class="item-counts">{{ countsObj.allFeedbacks }}</span>
            </a>
          </li>
          <li v-bind:class="{'is-active':tabsView==='Financials'}"
              v-on:click="tabsView = 'Financials'">
            <a>Financials</a>
          </li>
          <li v-bind:class="{'is-active':tabsView==='Reports'}"
              v-on:click="tabsView = 'Reports'">
            <a>Reports</a>
          </li>
          <li v-bind:class="{'is-active':tabsView==='Search'}"
              v-on:click="tabsView = 'Search'"
              v-if="searchingInProgress>0">
            <a>Search
              <span class="item-counts">{{ searchResults.length }}</span>
            </a>
          </li>
          <li v-bind:class="{'is-active':tabsView==='Admin'}"
              v-on:click="tabsView = 'Admin'" v-if="loginData.adminRole==='Yes'">
            <a>Admin</a>
          </li>
          <li v-bind:class="{'is-active':tabsView==='Funds'}"
              v-on:click="tabsView = 'Funds'" v-if="loginData.fundManager==='Yes'">
            <a>Funds</a>
          </li>
          <li v-bind:class="{'is-active':tabsView==='Cases'}"
              v-on:click="tabsView = 'Cases'" v-if="loginData.casesDataViewer==='Yes'">
            <a>Cases</a>
          </li>
        </ul>
      </div>
    </li>

    <li v-if="loginData.role==='Representative'">
      <div class="field is-grouped card-type-select pills-container hide-scrollbar" v-if="tabsView==='Profiles'">
        <p class="control" v-for="(repProfileChoice, index) in profileChoices.Representative"
           v-bind:key="`repProfileChoice${index}`">
          <button class="button is-rounded is-info is-fullwidth-mobile"
                  v-bind:class="{'is-outlined':subsectionsChoice !== repProfileChoice.text}"
                  v-on:click="changeSubsectionsChoice(repProfileChoice.text)">
            {{ repProfileChoice.text }}
            <span class="item-counts">{{ countsObj[repProfileChoice.endpoint] }}</span>
          </button>
        </p>
      </div>
      <div class="field is-grouped card-type-select pills-container hide-scrollbar" v-if="tabsView==='Feedbacks'">
        <p class="control" v-for="(repFeedbackChoice, index) in feedbackChoices.Representative"
           v-bind:key="`repFeedbackChoice${index}`">
          <button class="button is-rounded is-info is-fullwidth-mobile"
                  v-bind:class="{'is-outlined':subsectionsChoice !== repFeedbackChoice.text}"
                  v-on:click="changeSubsectionsChoice(repFeedbackChoice.text)">
            {{ repFeedbackChoice.text }}
            <span class="item-counts">{{ countsObj[repFeedbackChoice.endpoint] }}</span>
          </button>
        </p>
      </div>
      <div class="field is-grouped card-type-select pills-container hide-scrollbar" v-if="tabsView==='Financials'">
        <p class="control" v-for="(repFinancialsChoice, index) in financialsChoices.Representative"
           v-bind:key="`repFinancialsChoice${index}`">
          <button class="button is-rounded is-info is-fullwidth-mobile"
                  v-bind:class="{'is-outlined':subsectionsChoice !== repFinancialsChoice.text}"
                  v-on:click="changeSubsectionsChoice(repFinancialsChoice.text)">
            {{ repFinancialsChoice.text }}
            <span class="item-counts">{{ totalTableCounts[repFinancialsChoice.endpoint] }}</span>
          </button>
        </p>
      </div>
      <div class="field is-grouped card-type-select pills-container hide-scrollbar" v-if="tabsView==='Reports'">
        <p class="control" v-for="(repReportsChoice, index) in reportsChoices.Representative"
           v-bind:key="`repReportsChoice${index}`">
          <button class="button is-rounded is-info is-fullwidth-mobile"
                  v-bind:class="{'is-outlined':subsectionsChoice !== repReportsChoice.text}"
                  v-on:click="changeSubsectionsChoice(repReportsChoice.text)">
            {{ repReportsChoice.text }}
            <span class="item-counts">{{ totalTableCounts[repReportsChoice.endpoint] }}</span>
          </button>
        </p>
      </div>
      <div class="field is-grouped card-type-select pills-container hide-scrollbar" v-if="tabsView==='Cases'">
        <p class="control" v-for="(repCaseDataChoice, index) in caseDataChoices.Representative"
           v-bind:key="`repCaseDataChoice${index}`">
          <button class="button is-rounded is-info is-fullwidth-mobile"
                  v-bind:class="{'is-outlined':subsectionsChoice !== repCaseDataChoice.text}"
                  v-on:click="changeSubsectionsChoice(repCaseDataChoice.text)">
            {{ repCaseDataChoice.text }}
          </button>
        </p>
      </div>
    </li>

    <li v-if="loginData.role==='Coordinator'">
      <div class="field is-grouped card-type-select pills-container hide-scrollbar" v-if="tabsView==='Profiles'">
        <p class="control" v-for="(coordProfileChoice, index) in profileChoices.Coordinator"
           v-bind:key="`coordProfileChoice${index}`">
          <button class="button is-rounded is-info is-fullwidth-mobile"
                  v-bind:class="{'is-outlined':subsectionsChoice !== coordProfileChoice.text}"
                  v-on:click="changeSubsectionsChoice(coordProfileChoice.text)">
            {{ coordProfileChoice.text }}
            <span class="item-counts">{{ countsObj[coordProfileChoice.endpoint] }}</span>
          </button>
        </p>
      </div>
      <div class="field is-grouped card-type-select pills-container hide-scrollbar" v-if="tabsView==='Feedbacks'">
        <p class="control" v-for="(coordFeedbackChoice, index) in feedbackChoices.Coordinator"
           v-bind:key="`coordFeedbackChoice${index}`">
          <button class="button is-rounded is-info is-fullwidth-mobile"
                  v-bind:class="{'is-outlined':subsectionsChoice !== coordFeedbackChoice.text}"
                  v-on:click="changeSubsectionsChoice(coordFeedbackChoice.text)">
            {{ coordFeedbackChoice.text }}
            <span class="item-counts">{{ countsObj[coordFeedbackChoice.endpoint] }}</span>
          </button>
        </p>
      </div>
      <div class="field is-grouped card-type-select pills-container hide-scrollbar" v-if="tabsView==='Financials'">
        <p class="control" v-for="(coordFinancialsChoice, index) in financialsChoices.Coordinator"
           v-bind:key="`coordFinancialsChoice${index}`">
          <button class="button is-rounded is-info is-fullwidth-mobile"
                  v-bind:class="{'is-outlined':subsectionsChoice !== coordFinancialsChoice.text}"
                  v-on:click="changeSubsectionsChoice(coordFinancialsChoice.text)">
            {{ coordFinancialsChoice.text }}
            <span class="item-counts">{{ totalTableCounts[coordFinancialsChoice.endpoint] }}</span>
          </button>
        </p>
      </div>
      <div class="field is-grouped card-type-select pills-container hide-scrollbar" v-if="tabsView==='Reports'">
        <p class="control" v-for="(coordReportsChoice, index) in reportsChoices.Coordinator"
           v-bind:key="`coordReportsChoice${index}`">
          <button class="button is-rounded is-info is-fullwidth-mobile"
                  v-bind:class="{'is-outlined':subsectionsChoice !== coordReportsChoice.text}"
                  v-on:click="changeSubsectionsChoice(coordReportsChoice.text)">
            {{ coordReportsChoice.text }}
            <span class="item-counts">{{ totalTableCounts[coordReportsChoice.endpoint] }}</span>
          </button>
        </p>
      </div>
      <div class="field is-grouped card-type-select pills-container hide-scrollbar" v-if="tabsView==='Admin'">
        <p class="control" v-for="(coordAdminChoice, index) in adminChoices.Coordinator"
           v-bind:key="`coordAdminChoice${index}`">
          <button class="button is-rounded is-info is-fullwidth-mobile"
                  v-bind:class="{'is-outlined':subsectionsChoice !== coordAdminChoice.text}"
                  v-on:click="changeSubsectionsChoice(coordAdminChoice.text)">
            {{ coordAdminChoice.text }}
          </button>
        </p>
      </div>
      <div class="field is-grouped card-type-select pills-container hide-scrollbar" v-if="tabsView==='Funds'">
        <p class="control" v-for="(coordFundsChoice, index) in fundsChoices.Coordinator"
           v-bind:key="`coordFundsChoice${index}`">
          <button class="button is-rounded is-info is-fullwidth-mobile"
                  v-bind:class="{'is-outlined':subsectionsChoice !== coordFundsChoice.text}"
                  v-on:click="changeSubsectionsChoice(coordFundsChoice.text)">
            {{ coordFundsChoice.text }}
          </button>
        </p>
      </div>
      <div class="field is-grouped card-type-select pills-container hide-scrollbar" v-if="tabsView==='Cases'">
        <p class="control" v-for="(coordCaseDataChoice, index) in caseDataChoices.Coordinator"
           v-bind:key="`coordCaseDataChoice${index}`">
          <button class="button is-rounded is-info is-fullwidth-mobile"
                  v-bind:class="{'is-outlined':subsectionsChoice !== coordCaseDataChoice.text}"
                  v-on:click="changeSubsectionsChoice(coordCaseDataChoice.text)">
            {{ coordCaseDataChoice.text }}
          </button>
        </p>
      </div>
    </li>


    <li v-if="liSubsectionsView !== 'Draft Profiles' && liSubsectionsView !== 'Draft Feedbacks' && caseViews !== 'No Cases' && liSubsectionsView !== 'Search'">
      <div class="column is-full">
        <div class="tabs is-centered">
          <ul>
            <li v-bind:class="{'is-active':caseViews==='Emergency'}" v-on:click="caseViewSelected='Emergency'">
              <a>Emergency Cases - {{ categoryCounts.emergencyCases }}</a>
            </li>
            <li v-bind:class="{'is-active':caseViews==='Elective'}" v-on:click="caseViewSelected='Elective'">
              <a>Elective Cases - {{ categoryCounts.electiveCases }}</a>
            </li>
          </ul>
        </div>
      </div>
    </li>
    <li v-if="liSubsectionsView !== 'Draft Profiles' && liSubsectionsView !== 'Draft Feedbacks' && noCasesView && liSubsectionsView !== 'Search'"
        class="notification is-warning is-light notification-safeapp"
        v-bind:class="{'is-hidden':caseViews !== 'No Cases'}">
      There are no cases in this category or stage.
    </li>


    <div class="container-fluid box box-with-no-bg" v-if="showTablesToolbar">
      <div class="columns is-multiline is-vcentered">

        <div class="column is-one-fifth-fullhd is-one-fifth-desktop is-full-tablet is-full-mobile"
             v-if="showPaidUnpaidChecks">
          <label class="label has-text-centered">Financials Type</label>
          <div class="field is-narrow">
            <div class="control">
              <div class="fancy-input-group padded-checkboxes columns is-centered is-multiline is-vcentered">
                <input type="checkbox" name="throughapp" id="throughapp"
                       value="throughapp"
                       class="fancy-input"
                       v-model="financialsType.throughapp"/>
                <label for="throughapp"
                       class="fancy-input-label column is-narrow no-wrapping-label margin-5-button">Through App</label>
                <input type="checkbox" name="outsideapp" id="outsideapp"
                       value="outsideapp"
                       class="fancy-input"
                       v-model="financialsType.outsideapp"/>
                <label for="outsideapp"
                       class="fancy-input-label column is-narrow no-wrapping-label margin-5-button">Outside App</label>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-one-fifth-fullhd is-one-fifth-desktop is-full-tablet is-full-mobile">
          <label class="label has-text-centered">Case Year</label>
          <div class="field is-narrow">
            <div class="control">
              <div class="fancy-input-group padded-checkboxes columns is-centered is-multiline is-vcentered">
                <input type="checkbox" name="financeyear2026" id="financeyear2026"
                       value="financeyear2026"
                       class="fancy-input"
                       v-model="financeReportsYear.year2026"/>
                <label for="financeyear2026"
                       class="fancy-input-label column is-narrow no-wrapping-label margin-5-button">2026</label>
                <input type="checkbox" name="financeyear2025" id="financeyear2025"
                       value="financeyear2025"
                       class="fancy-input"
                       v-model="financeReportsYear.year2025"/>
                <label for="financeyear2025"
                       class="fancy-input-label column is-narrow no-wrapping-label margin-5-button">2025</label>
                <input type="checkbox" name="financeyear2024" id="financeyear2024"
                       value="financeyear2024"
                       class="fancy-input"
                       v-model="financeReportsYear.year2024"/>
                <label for="financeyear2024"
                       class="fancy-input-label column is-narrow no-wrapping-label margin-5-button">2024</label>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-full-tablet is-full-mobile"
             v-bind:class="{'is-two-fifths-fullhd is-two-fifths-desktop':showPaidUnpaidChecks,'is-three-fifths-fullhd is-three-fifths-desktop':!showPaidUnpaidChecks}">
          <label class="label has-text-centered">Fund Pocket</label>
          <div class="field is-narrow">
            <div class="control">
              <div class="fancy-input-group padded-checkboxes columns is-centered is-multiline is-vcentered">
                <input type="checkbox" name="financepocketwatsi" id="financepocketwatsi"
                       value="financepocketwatsi"
                       class="fancy-input"
                       v-model="financeReportsPocket.pocketwatsi"/>
                <label for="financepocketwatsi"
                       class="fancy-input-label column is-narrow no-wrapping-label margin-5-button">Watsi</label>
                <input type="checkbox" name="amh" id="financepocketamhecs"
                       value="financepocketamhecs"
                       class="fancy-input"
                       v-model="financeReportsPocket.pocketamhecs"/>
                <label for="financepocketamhecs"
                       class="fancy-input-label column is-narrow no-wrapping-label margin-5-button">AMH
                  ECS</label>
                <input type="checkbox" name="amh" id="financepocketamhsdv"
                       value="financepocketamhsdv"
                       class="fancy-input"
                       v-model="financeReportsPocket.pocketamhsdv"/>
                <label for="financepocketamhsdv"
                       class="fancy-input-label column is-centered is-narrow no-wrapping-label margin-5-button">AMH
                  SVD</label>
                <input type="checkbox" name="amh" id="financepocketcontingency"
                       value="financepocketcontingency"
                       class="fancy-input"
                       v-model="financeReportsPocket.pocketcontingency"/>
                <label for="financepocketcontingency"
                       class="fancy-input-label column is-centered is-narrow no-wrapping-label margin-5-button">Contingency</label>
                <input type="checkbox" name="amh" id="financepocketamhother"
                       value="financepocketamhother"
                       class="fancy-input"
                       v-model="financeReportsPocket.pocketamhother"/>
                <label for="financepocketamhother"
                       class="fancy-input-label column is-narrow no-wrapping-label margin-5-button">AMH
                  Other</label>
                <input type="checkbox" name="amh" id="financepocketamhunallocated"
                       value="financepocketamhunallocated"
                       class="fancy-input"
                       v-model="financeReportsPocket.pocketunallocated"/>
                <label for="financepocketamhunallocated"
                       class="fancy-input-label column is-narrow no-wrapping-label margin-5-button">Unallocated</label>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-one-fifth-fullhd is-one-fifth-desktop is-full-tablet is-full-mobile">
          <label class="label has-text-centered">Group By</label>
          <div class="field is-narrow">
            <div class="control">
              <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered">
                <input type="checkbox" name="financegrouppartner" id="financegrouppartner"
                       value="financegrouppartner"
                       class="fancy-input"
                       v-model="financeReportsGroup_partner_pocket.partnername"
                       v-if="loginData.role==='Coordinator'"/>
                <label for="financegrouppartner"
                       class="fancy-input-label column is-narrow no-wrapping-label margin-5-button"
                       v-if="loginData.role==='Coordinator'">Partner</label>
                <input type="checkbox" name="financegrouppocket" id="financegrouppocket"
                       value="financegrouppocket"
                       class="fancy-input"
                       v-model="financeReportsGroup_partner_pocket.p_approvalpocket"/>
                <label for="financegrouppocket"
                       class="fancy-input-label column is-narrow no-wrapping-label margin-5-button">Pocket</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <li class="notification is-warning is-light notification-safeapp"
        v-bind:class="{'is-hidden':liSubsectionsView !== 'Draft Profiles'}"
        v-show="draftProfilesCached">
      Showing draft profiles from cached records. Update loading...
    </li>
    <li v-for="(profile, index) in draftProfiles" v-bind:key="index"
        class="items-list card-list amh-card"
        v-bind:class="[typeof profile.returnProfileData !== 'undefined' ? 'AMH-yellow' : 'AMH-transitionGray', {'is-hidden':liSubsectionsView !== 'Draft Profiles'}]">
      <div class="card">
        <div class="progress progress-card progress-striped active" v-if="profile.dirtyState">
          <div role="progressbar" style="width: 100%;"
               class="progress-bar progress-bar-card progress-bar-default"></div>
        </div>
        <div class="card-content" v-if="profile.patientProfile">
          <div class="media">
            <div class="media-left">
              <figure class="image is-128x128 is-rounded">
                <img v-bind:src="`${profile.featuredImage}`" alt="Patient"
                     class="image is-128x128 is-rounded"
                     v-if="profile.featuredImage!==''">
                <img
                    v-bind:src="`${placeholdersBaseUrl}/profile/placeholder/personPlaceholder.png`"
                    alt="Med Rep" class="image is-128x128 is-rounded" v-else>
              </figure>
            </div>
            <div class="media-content">
              <p class="items-list bottom-margin-title title is-4"> {{ profile.patientProfile.patientInfo.name }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Creation Date:</strong> {{
                  profile.profileCreationDate
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Case Id:</strong> {{
                  profile.profileIdentifier
                }}</p>

              <p class="items-list subtitle is-6 no-margin-p has-text-centered is-underlined"
                 v-if="typeof profile.returnProfileData !== 'undefined'">Returning Information</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"
                 v-for="(returns_data, index) in profile.returnProfileData" v-bind:key="index"><span
                  class="returned-arrow">&rArr;</span>
                Returned by <strong>{{ returns_data.returned_by }}</strong> on {{
                  returns_data.returned_at
                }}<br>
                Reason: <strong>{{ returns_data.returned_reason }}</strong></p>

            </div>
          </div>
        </div>
        <div class="card-content" v-else>For Deletion</div>
        <footer class="card-footer">
          <a href="#" class="card-footer-item" v-if="profile.patientProfile"
             v-on:click="loadProfileForm(profile.profileIdentifier)">Load</a>
          <a href="#" class="card-footer-item" v-on:click="deleteProfileForm(profile.profileCreationTS)">Delete</a>
        </footer>
      </div>
    </li>

    <li class="notification is-warning is-light notification-safeapp"
        v-bind:class="{'is-hidden':liSubsectionsView !== 'Submitted Profiles' && liSubsectionsView !== 'Re-submitted Profiles'}"
        v-show="unapprovedProfilesCached">
      Showing submitted profiles from cached records. Update loading...
    </li>
    <li v-for="(profile, index) in filteredUnapprovedProfiles" v-bind:key="index"
        class="items-list card-list amh-card"
        v-bind:class="{'is-hidden':liSubsectionsView!=='Submitted Profiles' && liSubsectionsView!=='Re-submitted Profiles',
        'emergency-bg':caseViews==='Emergency',
        'AMH-blue':caseViews==='Elective'}">
      <div class="card">
        <div class="ribbon ribbon-top-right" v-if="profile.patientPrivacy!=='No'"><span>Privacy</span></div>
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-128x128 is-rounded">
                <img v-bind:src="`${profile.featuredImage}`" alt="Patient"
                     class="image is-128x128 is-rounded">
              </figure>
            </div>
            <div class="media-content">
              <p class="items-list bottom-margin-title title is-4"> {{ profile.patientName }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Age:</strong> {{
                  profile.patientDob
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery Required:</strong>
                {{ profile.surgeryRequired }}</p>
              <p class="items-list items-list subtitle is-6 no-margin-p has-text-left"><strong>Estimated Surgery
                Date:</strong>
                {{ profile.estimatedSurgeryDay }} ({{ profile.diffToEstimatesSurgeryText }})</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Partner:</strong>
                {{ profile.partnerIdentity }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Condition:</strong>
                {{ profile.patientCondition }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Case ID:</strong> {{
                  profile.profileIdentifier
                }}</p>
            </div>
          </div>
          <div class="content">
            <p class="items-list">This profile was submitted on <strong>{{ profile.profileCreationDate }}</strong> by
              <strong>{{ profile.repName }}</strong></p>
            <p class="items-list has-text-left"><strong>Safe Ask:</strong> {{ profile.safeAskAmount }}</p>
          </div>
        </div>
        <footer class="card-footer">
          <a href="#" class="card-footer-item" v-on:click="viewProfileData(profile.profileIdentifier,true)">Details</a>
        </footer>
      </div>
    </li>

    <li class="notification is-warning is-light notification-safeapp"
        v-bind:class="{'is-hidden':liSubsectionsView !== 'Approved Profiles'}"
        v-show="approvedProfilesCached">
      Showing approved profiles from cached records. Update loading...
    </li>
    <li v-for="(profile, index) in filteredApprovedProfiles" v-bind:key="index"
        class="items-list card-list amh-card"
        v-bind:class="{'is-hidden':liSubsectionsView!=='Approved Profiles',
        'emergency-bg':caseViews==='Emergency',
        'AMH-green':caseViews==='Elective'}">
      <div class="card">
        <div class="ribbon ribbon-top-right" v-if="profile.patientPrivacy!=='No'"><span>Privacy</span></div>
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-128x128 is-rounded">
                <img v-bind:src="`${profile.featuredImage}`" alt="Patient"
                     class="image is-128x128 is-rounded">
              </figure>
            </div>
            <div class="media-content">
              <p class="items-list bottom-margin-title title is-4"> {{ profile.patientName }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Age:</strong> {{
                  profile.patientDob
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery Required:</strong>
                {{ profile.surgeryRequired }}</p>
              <p class="items-list items-list subtitle is-6 no-margin-p has-text-left"><strong>Estimated Surgery
                Date:</strong>
                {{ profile.estimatedSurgeryDay }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Partner:</strong>
                {{ profile.partnerIdentity }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Condition:</strong>
                {{ profile.patientCondition }}</p>
            </div>
          </div>
          <div class="content">
            <p class="items-list has-text-left">Submitted on <strong>{{ profile.profileCreationDate }}</strong> by
              <strong>{{ profile.repName }}</strong></p>
            <p class="items-list has-text-left">Approved on <strong>{{ profile.approved_at }}</strong> by
              <strong>{{ profile.approved_by }}</strong></p>
            <p class="items-list has-text-left"><strong>Safe Ask:</strong> {{ profile.safeAskAmount }}</p>
          </div>
        </div>
        <footer class="card-footer">

          <a href="#" class="card-footer-item" v-if="loginData.role==='Representative' && !profile.inDraftFeedbacks"
             v-on:click="startFeedbackForm(profile.profileIdentifier)">Feedback</a>

          <span v-if="loginData.role==='Representative' && profile.inDraftFeedbacks" class="card-footer-item">In Draft Feedbacks</span>

          <a href="#" class="card-footer-item" v-if="loginData.role==='Coordinator'"
             v-on:click="viewProfileData(profile.profileIdentifier,false)">Comment</a>
        </footer>
      </div>
    </li>

    <li class="notification is-warning is-light notification-safeapp"
        v-bind:class="{'is-hidden':liSubsectionsView !== 'Returned Profiles'}"
        v-show="returnedProfilesCached">
      Showing returned profiles from cached records. Update loading...
    </li>
    <li v-for="(profile, index) in filteredReturnedProfiles" v-bind:key="index"
        class="items-list card-list amh-card"
        v-bind:class="{'is-hidden':liSubsectionsView!=='Returned Profiles',
        'emergency-bg':caseViews==='Emergency',
        'AMH-yellow':caseViews==='Elective'}">
      <div class="card">
        <div class="progress progress-card progress-striped active" v-if="profile.dirtyState">
          <div role="progressbar" style="width: 100%;"
               class="progress-bar progress-bar-card progress-bar-default"></div>
        </div>
        <div class="ribbon ribbon-top-right" v-if="profile.patientPrivacy!=='No'"><span>Privacy</span></div>
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-128x128 is-rounded">
                <img v-bind:src="`${profile.featuredImage}`" alt="Patient"
                     class="image is-128x128 is-rounded"
                     v-if="profile.featuredImage!==''">
                <img
                    v-bind:src="`${placeholdersBaseUrl}/profile/placeholder/personPlaceholder.png`"
                    alt="Med Rep" class="image is-128x128 is-rounded" v-else>
              </figure>
            </div>
            <div class="media-content">
              <p class="items-list bottom-margin-title title is-4"> {{ profile.patientName }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Creation Date:</strong> {{
                  profile.profileCreationDate
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Case Id:</strong> {{
                  profile.profileIdentifier
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-centered is-underlined">Returning Information</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"
                 v-for="(returns_data, index) in profile.returns_data" v-bind:key="index"><span class="returned-arrow">&rArr;</span>
                Returned by <strong>{{ returns_data.returned_by }}</strong> on <strong>{{
                    returns_data.returned_at
                  }}</strong><br>
                Reason: <strong>{{ returns_data.returned_reason }}</strong></p>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <a href="#" class="card-footer-item" v-on:click="loadReturnedProfileForm(profile.profileIdentifier)"
             v-if="loginData.role==='Representative'">Draft</a>
          <a href="#" class="card-footer-item" v-on:click="deleteProfileForm(profile.profileIdentifier)"
             v-if="loginData.role==='Representative'">Delete</a>
        </footer>
      </div>
    </li>

    <li class="notification is-warning is-light notification-safeapp"
        v-bind:class="{'is-hidden':liSubsectionsView !== 'Rejected Profiles'}"
        v-show="rejectedProfilesCached">
      Showing rejected profiles from cached records. Update loading...
    </li>
    <li v-for="(profile, index) in filteredRejectedProfiles" v-bind:key="index"
        class="items-list card-list amh-card"
        v-bind:class="{'is-hidden':liSubsectionsView!=='Rejected Profiles',
        'emergency-bg':caseViews==='Emergency',
        'AMH-red':caseViews==='Elective'}">
      <div class="card">
        <div class="ribbon ribbon-top-right" v-if="profile.patientPrivacy!=='No'"><span>Privacy</span></div>
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-128x128 is-rounded">
                <img v-bind:src="`${profile.featuredImage}`" alt="Patient"
                     class="image is-128x128 is-rounded">
              </figure>
            </div>
            <div class="media-content">
              <p class="items-list bottom-margin-title title is-4"> {{ profile.patientName }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Age:</strong> {{
                  profile.patientDob
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery Required:</strong>
                {{ profile.surgeryRequired }}</p>
              <p class="items-list items-list subtitle is-6 no-margin-p has-text-left"><strong>Estimated Surgery
                Date:</strong>
                {{ profile.estimatedSurgeryDay }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Partner:</strong>
                {{ profile.partnerIdentity }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Condition:</strong>
                {{ profile.patientCondition }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Case ID:</strong> {{
                  profile.profileIdentifier
                }}</p>
            </div>
          </div>
          <div class="content">
            <p class="items-list has-text-left">Submitted on <strong>{{ profile.profileCreationDate }}</strong> by
              <strong>{{ profile.repName }}</strong></p>
            <p class="items-list has-text-left">Rejected on <strong>{{ profile.rejected_at }}</strong> by
              <strong>{{ profile.rejected_by }}</strong></p>
            <p class="items-list has-text-left">Rejection reason: <strong>
              {{ profile.rejection_reason }}</strong></p>
            <p class="items-list has-text-left"><strong>Safe Ask:</strong> {{ profile.safeAskAmount }}</p>
          </div>
        </div>
        <footer class="card-footer">
          <a href="#" class="card-footer-item"
             v-on:click="loadRejectedProfileForm(profile.profileIdentifier)">View</a>
        </footer>
      </div>
    </li>


    <li class="notification is-warning is-light notification-safeapp"
        v-bind:class="{'is-hidden':liSubsectionsView !== 'Draft Feedbacks'}"
        v-show="draftFeedbacksCached">
      Showing draft feedbacks from cached records. Update loading...
    </li>
    <li v-for="(feedback, index) in draftFeedbacks" v-bind:key="index"
        class="items-list card-list amh-card AMH-transitionGray"
        v-bind:class="{'is-hidden':liSubsectionsView !== 'Draft Feedbacks'}">
      <div class="card">
        <div class="card-content" v-if="feedback.patientFeedback && feedback.profileSummary">
          <div class="media">
            <div class="media-left">
              <figure class="image is-128x128 is-rounded">
                <img v-bind:src="`${feedback.profileSummary.featuredImage}`" alt="Patient"
                     class="image is-128x128 is-rounded"
                     v-if="feedback.featuredImage.indexOf('personPlaceholder.png')>0">
                <img
                    v-bind:src="`${feedback.featuredImage}`"
                    alt="Patient" class="image is-128x128 is-rounded" v-else>
              </figure>
            </div>
            <div class="media-content">
              <p class="items-list bottom-margin-title title is-4"> {{ feedback.profileSummary.patientName }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Case ID:</strong> {{
                  feedback.profileIdentifier
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery:</strong> {{
                  feedback.profileSummary.surgeryRequired
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Profile Creation:</strong> {{
                  feedback.profileCreationDate
                }}</p>
            </div>
          </div>
        </div>
        <div class="card-content" v-else>There is an issue with case {{ feedback.profileIdentifier }}. Please contact
          the coordinator.
        </div>
        <footer class="card-footer">
          <a href="#" class="card-footer-item" v-if="feedback.patientFeedback && feedback.profileSummary"
             v-on:click="loadFeedbackForm(feedback.profileIdentifier)">Load</a>
          <a href="#" class="card-footer-item" v-on:click="deleteFeedbackForm(feedback.profileCreationTS)">Delete</a>
        </footer>
      </div>
    </li>

    <li class="notification is-warning is-light notification-safeapp"
        v-bind:class="{'is-hidden':liSubsectionsView!=='Submitted Feedbacks' && liSubsectionsView!=='Re-submitted Feedbacks'}"
        v-show="unapprovedFeedbacksCached">
      Showing submitted feedbacks from cached records. Update loading...
    </li>
    <li v-for="(unapprovedMergedFeedback, index) in filteredUnapprovedFeedbacks" v-bind:key="index"
        class="items-list card-list amh-card"
        v-bind:class="{'is-hidden':liSubsectionsView!=='Submitted Feedbacks' && liSubsectionsView!=='Re-submitted Feedbacks',
        'emergency-bg':caseViews==='Emergency',
        'AMH-blue':caseViews==='Elective'}">
      <div class="card">
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-128x128 is-rounded">
                <img v-bind:src="`${unapprovedMergedFeedback.feedback.featuredImage}`" alt="Patient"
                     class="image is-128x128 is-rounded">
              </figure>
            </div>
            <div class="media-content">
              <p class="items-list bottom-margin-title title is-4"> {{
                  unapprovedMergedFeedback.profile.patientName
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Case ID:</strong> {{
                  unapprovedMergedFeedback.Identifier
                }}
              </p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery Status:</strong> {{
                  unapprovedMergedFeedback.feedback.surgeryStatus
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery:</strong> {{
                  unapprovedMergedFeedback.feedback.actualSurgery
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Admission:</strong>
                {{ unapprovedMergedFeedback.feedback.admissionData }}</p>
              <p class="items-list items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery:</strong>
                {{ unapprovedMergedFeedback.feedback.surgeryData }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Discharge:</strong>
                {{ unapprovedMergedFeedback.feedback.dischargeData }}</p>
            </div>
          </div>
          <div class="content">
            <p class="items-list">This feedback was submitted on <strong>{{
                unapprovedMergedFeedback.feedback.submitted_at
              }}</strong> by
              <strong>{{ unapprovedMergedFeedback.feedback.submitted_by }}</strong></p>
            <p class="items-list has-text-left"><strong>Final Bill:</strong>
              {{ unapprovedMergedFeedback.feedback.finalBill }}</p>
          </div>
        </div>
        <footer class="card-footer">
          <a href="#" class="card-footer-item" v-if="loginData.role==='Coordinator'"
             v-on:click="QAFeedbackData(unapprovedMergedFeedback.Identifier)">Details</a>
          <a href="#" class="card-footer-item" v-if="loginData.role==='Representative'"
             v-on:click="viewFeedbackData(unapprovedMergedFeedback.Identifier)">View</a>
        </footer>
      </div>
    </li>

    <li class="notification is-warning is-light notification-safeapp"
        v-bind:class="{'is-hidden':liSubsectionsView!=='Returned Feedbacks'}"
        v-show="returnedFeedbacksCached">
      Showing returned feedbacks from cached records. Update loading...
    </li>
    <li v-for="(returnedMergedFeedback, index) in filteredReturnedFeedbacks" v-bind:key="index"
        class="items-list card-list amh-card"
        v-bind:class="{'is-hidden':liSubsectionsView!=='Returned Feedbacks',
         'emergency-bg':caseViews==='Emergency',
        'AMH-yallow':caseViews==='Elective'}">
      <div class="card">
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-128x128 is-rounded">
                <img v-bind:src="`${returnedMergedFeedback.feedback.featuredImage}`" alt="Patient"
                     class="image is-128x128 is-rounded">
              </figure>
            </div>
            <div class="media-content">
              <p class="items-list bottom-margin-title title is-4"> {{ returnedMergedFeedback.profile.patientName }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Case ID:</strong> {{
                  returnedMergedFeedback.Identifier
                }}
              </p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery Status:</strong> {{
                  returnedMergedFeedback.feedback.surgeryStatus
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery:</strong> {{
                  returnedMergedFeedback.feedback.actualSurgery
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Admission:</strong>
                {{ returnedMergedFeedback.feedback.admissionData }}</p>
              <p class="items-list items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery:</strong>
                {{ returnedMergedFeedback.feedback.surgeryData }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Discharge:</strong>
                {{ returnedMergedFeedback.feedback.dischargeData }}</p>
            </div>
          </div>
          <div class="content">
            <p class="items-list">This feedback was submitted on <strong>{{
                returnedMergedFeedback.feedback.submitted_at
              }}</strong> by
              <strong>{{ returnedMergedFeedback.feedback.submitted_by }}</strong></p>

            <p class="items-list has-text-left"><strong>Final Bill:</strong>
              {{ returnedMergedFeedback.feedback.finalBill }}</p>

            <p class="items-list subtitle is-6 no-margin-p has-text-centered is-underlined">Returning Information</p>
            <p class="items-list subtitle is-6 no-margin-p has-text-left"
               v-for="(returns_data, index) in returnedMergedFeedback.feedback.returns_data" v-bind:key="index"><span
                class="returned-arrow">&rArr;</span>
              Returned by <strong>{{ returns_data.returned_by }}</strong> on <strong>{{
                  returns_data.returned_at
                }}</strong><br>
              Reason: <strong>{{ returns_data.returned_reason }}</strong></p>
          </div>
        </div>
        <footer class="card-footer">
          <a href="#" class="card-footer-item" v-on:click="editFeedbackForm(returnedMergedFeedback.Identifier)"
             v-if="loginData.role==='Representative' && !inDraftFeedbacks(returnedMergedFeedback.Identifier)">Amend</a>
          <span class="card-footer-item"
                v-if="loginData.role==='Representative' && inDraftFeedbacks(returnedMergedFeedback.Identifier)">In Draft Feedbacks</span>
        </footer>
      </div>
    </li>

    <li class="notification is-warning is-light notification-safeapp"
        v-bind:class="{'is-hidden':liSubsectionsView!=='Pulled Feedbacks'}"
        v-show="closedFeedbacksCached">
      Showing pulled feedbacks from cached records. Update loading...
    </li>
    <li v-for="(closedMergedFeedback, index) in filteredClosedFeedbacks" v-bind:key="index"
        class="items-list card-list amh-card"
        v-bind:class="{'is-hidden':liSubsectionsView!=='Pulled Feedbacks',
         'emergency-bg':caseViews==='Emergency',
        'AMH-red':caseViews==='Elective'}">
      <div class="card">
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-128x128 is-rounded">
                <img v-bind:src="`${closedMergedFeedback.feedback.featuredImage}`" alt="Patient"
                     class="image is-128x128 is-rounded">
              </figure>
            </div>
            <div class="media-content">
              <p class="items-list bottom-margin-title title is-4"> {{ closedMergedFeedback.profile.patientName }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Case ID:</strong> {{
                  closedMergedFeedback.Identifier
                }}
              </p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery Status:</strong> {{
                  closedMergedFeedback.feedback.surgeryStatus
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery:</strong> {{
                  closedMergedFeedback.feedback.actualSurgery
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Admission:</strong>
                {{ closedMergedFeedback.feedback.admissionData }}</p>
              <p class="items-list items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery:</strong>
                {{ closedMergedFeedback.feedback.surgeryData }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Discharge:</strong>
                {{ closedMergedFeedback.feedback.dischargeData }}</p>
            </div>
          </div>
          <div class="content">
            <p class="items-list">This feedback was submitted on <strong>{{
                closedMergedFeedback.feedback.submitted_at
              }}</strong> by
              <strong>{{ closedMergedFeedback.feedback.submitted_by }}</strong></p>
            <p class="items-list has-text-left"><strong>Final Bill:</strong> {{
                closedMergedFeedback.feedback.finalBill
              }}</p>

            <p class="items-list subtitle is-6 no-margin-p has-text-centered is-underlined">Closing Information</p>
            <p class="items-list subtitle is-6 no-margin-p has-text-left"><span
                class="returned-arrow">&rArr;</span>
              Closed on <strong>{{ closedMergedFeedback.feedback.closed_at }}</strong>
              by<strong>{{ closedMergedFeedback.feedback.closed_by }}</strong><br>
              Surgery Status: <strong>{{ closedMergedFeedback.feedback.surgery_status }}</strong><br>
              Representative Reason: <strong>{{ closedMergedFeedback.feedback.rep_reason }}</strong><br>
              Coordinator Reason: <strong>{{ closedMergedFeedback.feedback.coord_reason }}</strong>


            </p>
          </div>
        </div>
        <footer class="card-footer">
        </footer>
      </div>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Not Invoiced Financials'}">
      <dataTablesComponent
          ref="awaitingPartnerInvoiceFinancials"
          v-bind:loginData="loginData"
          v-bind:tableData="awaitingPartnerInvoiceFinancials"
          v-bind:filterForPartner="filterForPartner"
          v-bind:tableRef="'awaitingPartnerInvoiceFinancials'"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-bind:drawTime="drawTime"
          v-bind:updatePatientInvoiceRefresh="updatePatientInvoiceRefresh"
          v-bind:financeReportsGroup="financeReportsGroup_partner_pocket"
          v-bind:financeReportsPocket="financeReportsPocket"
          v-bind:financeReportsYear="financeReportsYear"
          v-bind:financialsType="financialsType"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Invoiced Financials'}">
      <dataTablesComponent
          ref="attachedPartnerInvoiceFinancials"
          v-bind:loginData="loginData"
          v-bind:tableData="attachedPartnerInvoiceFinancials"
          v-bind:filterForPartner="filterForPartner"
          v-bind:tableRef="'attachedPartnerInvoiceFinancials'"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-bind:drawTime="drawTime"
          v-bind:updatePatientInvoiceRefresh="updatePatientInvoiceRefresh"
          v-bind:financeReportsGroup="financeReportsGroup_partner_pocket"
          v-bind:financeReportsPocket="financeReportsPocket"
          v-bind:financeReportsYear="financeReportsYear"
          v-bind:financialsType="financialsType"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Generate AMH Invoice Financials'}">
      <amhInvoiceGenerationForm v-bind:loginData="loginData"/>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='AMH Invoice Financials'}">
      <dataTablesComponent
          ref="sentAmhInvoiceFinancials"
          v-bind:loginData="loginData"
          v-bind:tableData="sentAmhInvoiceFinancials"
          v-bind:filterForPartner="filterForPartner"
          v-bind:tableRef="'sentAmhInvoiceFinancials'"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-bind:drawTime="drawTime"
          v-bind:updatePatientInvoiceRefresh="updatePatientInvoiceRefresh"
          v-bind:financeReportsGroup="financeReportsGroup_partner_pocket"
          v-bind:financeReportsPocket="financeReportsPocket"
          v-bind:financeReportsYear="financeReportsYear"
          v-bind:financialsType="financialsType"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Remittance Financials'}">
      <dataTablesComponent
          ref="awaitingAmhRemittanceFinancials"
          v-bind:loginData="loginData"
          v-bind:tableData="awaitingAmhRemittanceFinancials"
          v-bind:filterForPartner="filterForPartner"
          v-bind:tableRef="'awaitingAmhRemittanceFinancials'"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-bind:drawTime="drawTime"
          v-bind:updatePatientInvoiceRefresh="updatePatientInvoiceRefresh"
          v-bind:financeReportsGroup="financeReportsGroup_partner_pocket"
          v-bind:financeReportsPocket="financeReportsPocket"
          v-bind:financeReportsYear="financeReportsYear"
          v-bind:financialsType="financialsType"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Receipt Financials'}">
      <dataTablesComponent
          ref="awaitingPartnerReceiptFinancials"
          v-bind:loginData="loginData"
          v-bind:tableData="awaitingPartnerReceiptFinancials"
          v-bind:filterForPartner="filterForPartner"
          v-bind:tableRef="'awaitingPartnerReceiptFinancials'"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-bind:drawTime="drawTime"
          v-bind:updatePatientInvoiceRefresh="updatePatientInvoiceRefresh"
          v-bind:financeReportsGroup="financeReportsGroup_partner_pocket"
          v-bind:financeReportsPocket="financeReportsPocket"
          v-bind:financeReportsYear="financeReportsYear"
          v-bind:financialsType="financialsType"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Verification Financials'}">
      <dataTablesComponent
          ref="receivedPartnerReceiptFinancials"
          v-bind:loginData="loginData"
          v-bind:tableData="receivedPartnerReceiptFinancials"
          v-bind:filterForPartner="filterForPartner"
          v-bind:tableRef="'receivedPartnerReceiptFinancials'"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-bind:drawTime="drawTime"
          v-bind:updatePatientInvoiceRefresh="updatePatientInvoiceRefresh"
          v-bind:financeReportsGroup="financeReportsGroup_partner_pocket"
          v-bind:financeReportsPocket="financeReportsPocket"
          v-bind:financeReportsYear="financeReportsYear"
          v-bind:financialsType="financialsType"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Completed Financials'}">
      <dataTablesComponent
          ref="completedFinancials"
          v-bind:loginData="loginData"
          v-bind:tableData="completedFinancials"
          v-bind:filterForPartner="filterForPartner"
          v-bind:tableRef="'completedFinancials'"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-bind:drawTime="drawTime"
          v-bind:updatePatientInvoiceRefresh="updatePatientInvoiceRefresh"
          v-bind:financeReportsGroup="financeReportsGroup_partner_pocket"
          v-bind:financeReportsPocket="financeReportsPocket"
          v-bind:financeReportsYear="financeReportsYear"
          v-bind:financialsType="financialsType"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Funds Utilization Reports'}">
      <dataTablesComponent
          ref="fundsUtilizationReportData"
          v-bind:loginData="loginData"
          v-bind:tableData="fundsUtilizationReportData"
          v-bind:filterForPartner="filterForPartner"
          v-bind:tableRef="'fundsUtilizationReportData'"
          v-on:tableRefreshTrigger="tableToRefresh"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Open Reports'}">
      <dataTablesComponent
          ref="openStageReports"
          v-bind:loginData="loginData"
          v-bind:tableData="openStageReports"
          v-bind:drawTime="drawTime"
          v-bind:filterForPartner="filterForPartner"
          v-bind:financeReportsGroup="financeReportsGroup_partner_pocket"
          v-bind:financeReportsPocket="financeReportsPocket"
          v-bind:financeReportsYear="financeReportsYear"
          v-bind:financialsType="financialsType"
          v-bind:tableRef="'openStageReports'"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Rejected Reports'}">
      <dataTablesComponent
          ref="rejectedStageReports"
          v-bind:loginData="loginData"
          v-bind:tableData="rejectedStageReports"
          v-bind:drawTime="drawTime"
          v-bind:filterForPartner="filterForPartner"
          v-bind:financeReportsGroup="financeReportsGroup_partner"
          v-bind:financeReportsPocket="financeReportsPocket"
          v-bind:financeReportsYear="financeReportsYear"
          v-bind:updatePatientInvoiceRefresh="updatePatientInvoiceRefresh"
          v-bind:financialsType="financialsType"
          v-bind:tableRef="'rejectedStageReports'"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Invoice Reports'}">
      <dataTablesComponent
          ref="invoiceStageReports"
          v-bind:loginData="loginData"
          v-bind:tableData="invoiceStageReports"
          v-bind:drawTime="drawTime"
          v-bind:filterForPartner="filterForPartner"
          v-bind:financeReportsGroup="financeReportsGroup_partner_pocket"
          v-bind:financeReportsPocket="financeReportsPocket"
          v-bind:financeReportsYear="financeReportsYear"
          v-bind:updatePatientInvoiceRefresh="updatePatientInvoiceRefresh"
          v-bind:financialsType="financialsType"
          v-bind:tableRef="'invoiceStageReports'"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Pulled Reports'}">
      <dataTablesComponent
          ref="pulledStageReports"
          v-bind:loginData="loginData"
          v-bind:tableData="pulledStageReports"
          v-bind:drawTime="drawTime"
          v-bind:filterForPartner="filterForPartner"
          v-bind:financeReportsGroup="financeReportsGroup_partner_pocket"
          v-bind:financeReportsPocket="financeReportsPocket"
          v-bind:financeReportsYear="financeReportsYear"
          v-bind:updatePatientInvoiceRefresh="updatePatientInvoiceRefresh"
          v-bind:financialsType="financialsType"
          v-bind:tableRef="'pulledStageReports'"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Cancelled Reports'}">
      <dataTablesComponent
          ref="cancelledStageReports"
          v-bind:loginData="loginData"
          v-bind:tableData="cancelledStageReports"
          v-bind:drawTime="drawTime"
          v-bind:filterForPartner="filterForPartner"
          v-bind:financeReportsGroup="financeReportsGroup_partner_pocket"
          v-bind:financeReportsPocket="financeReportsPocket"
          v-bind:financeReportsYear="financeReportsYear"
          v-bind:updatePatientInvoiceRefresh="updatePatientInvoiceRefresh"
          v-bind:financialsType="financialsType"
          v-bind:tableRef="'cancelledStageReports'"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Closed Reports'}">
      <dataTablesComponent
          ref="closedStageReports"
          v-bind:loginData="loginData"
          v-bind:tableData="closedStageReports"
          v-bind:drawTime="drawTime"
          v-bind:filterForPartner="filterForPartner"
          v-bind:financeReportsGroup="financeReportsGroup_partner_pocket"
          v-bind:financeReportsPocket="financeReportsPocket"
          v-bind:financeReportsYear="financeReportsYear"
          v-bind:updatePatientInvoiceRefresh="updatePatientInvoiceRefresh"
          v-bind:financialsType="financialsType"
          v-bind:tableRef="'closedStageReports'"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Closed Reports'}">
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Partners Admin'}">
      <dataTablesComponent
          ref="partnersAdmin"
          v-bind:loginData="loginData"
          v-bind:tableData="partnersAdmin"
          v-bind:drawTime="drawTime"
          v-bind:adminGroup="partnerAdminGroup"
          v-bind:tableRef="'partnersAdmin'"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Users Admin'}">
      <dataTablesComponent
          ref="usersAdmin"
          v-bind:loginData="loginData"
          v-bind:tableData="usersAdmin"
          v-bind:drawTime="drawTime"
          v-bind:adminGroup="userAdminGroup"
          v-bind:tableRef="'usersAdmin'"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-bind:updateUserAdminRefresh="updateUserAdminRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Pre-approvals Admin'}">
      <dataTablesComponent
          ref="preapprovalsAdmin"
          v-bind:loginData="loginData"
          v-bind:tableData="preapprovalsAdmin"
          v-bind:drawTime="drawTime"
          v-bind:adminGroup="preapprovalAdminGroup"
          v-bind:tableRef="'preapprovalsAdmin'"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Watsi Funds'}">
      <dataTablesComponent
          ref="watsiFunds"
          v-bind:loginData="loginData"
          v-bind:tableData="PocketFundsWatsi"
          v-bind:drawTime="drawTime"
          v-bind:adminGroup="partnerAdminGroup"
          v-bind:tableRef="'watsiFunds'"
          v-bind:updateFundAllocationRefresh="updateFundAllocationRefresh"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>
    <li v-bind:class="{'is-hidden':liSubsectionsView!=='AMH Contingency Funds'}">
      <dataTablesComponent
          ref="amhcontingencyFunds"
          v-bind:loginData="loginData"
          v-bind:tableData="PocketFundsContingency"
          v-bind:drawTime="drawTime"
          v-bind:adminGroup="partnerAdminGroup"
          v-bind:tableRef="'amhcontingencyFunds'"
          v-bind:updateFundAllocationRefresh="updateFundAllocationRefresh"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>
    <li v-bind:class="{'is-hidden':liSubsectionsView!=='AMH ECS Funds'}">
      <dataTablesComponent
          ref="amhecsFunds"
          v-bind:loginData="loginData"
          v-bind:tableData="PocketFundsEcs"
          v-bind:drawTime="drawTime"
          v-bind:adminGroup="partnerAdminGroup"
          v-bind:tableRef="'amhecsFunds'"
          v-bind:updateFundAllocationRefresh="updateFundAllocationRefresh"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>
    <li v-bind:class="{'is-hidden':liSubsectionsView!=='AMH SVD Funds'}">
      <dataTablesComponent
          ref="amhsvdFunds"
          v-bind:loginData="loginData"
          v-bind:tableData="PocketFundsSvd"
          v-bind:drawTime="drawTime"
          v-bind:adminGroup="partnerAdminGroup"
          v-bind:tableRef="'amhsvdFunds'"
          v-bind:updateFundAllocationRefresh="updateFundAllocationRefresh"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>
    <li v-bind:class="{'is-hidden':liSubsectionsView!=='AMH Other Funds'}">
      <dataTablesComponent
          ref="amhotherFunds"
          v-bind:loginData="loginData"
          v-bind:tableData="PocketFundsOther"
          v-bind:drawTime="drawTime"
          v-bind:adminGroup="partnerAdminGroup"
          v-bind:tableRef="'amhotherFunds'"
          v-bind:updateFundAllocationRefresh="updateFundAllocationRefresh"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li v-bind:class="{'is-hidden':liSubsectionsView!=='Active Cases'}">
      <dataTablesComponent
          ref="activeDataCases"
          v-bind:loginData="loginData"
          v-bind:tableData="ActiveDataCases"
          v-bind:drawTime="drawTime"
          v-bind:adminGroup="activeCasesDataGroup"
          v-bind:filterForPartner="filterForPartner"
          v-bind:tableRef="'activeDataCases'"
          v-bind:updateFundAllocationRefresh="updateFundAllocationRefresh"
          v-on:tableRefreshTrigger="tableToRefresh"
          v-on:totalRecords="updateTotalRecords"
          v-if="homePageVarsLoaded"
      ></dataTablesComponent>
    </li>

    <li class="notification is-warning is-light notification-safeapp"
        v-bind:class="{'is-hidden':liSubsectionsView!=='Search'}"
        v-show="searchingInProgress===1">
      Searching...
    </li>
    <li class="notification is-warning is-light notification-safeapp"
        v-bind:class="{'is-hidden':liSubsectionsView!=='Search'}"
        v-show="searchingInProgress===3">
      No records found
    </li>
    <li v-for="(searchResult, index) in searchResults" v-bind:key="index"
        class="items-list card-list amh-card"
        v-bind:class="{
      'is-hidden':liSubsectionsView!=='Search',
      'AMH-blue':searchResult.recordType==='submittedprofile' || searchResult.recordType==='submittedfeedback',
      'AMH-green':searchResult.recordType==='approvedprofile',
      'AMH-yellow':searchResult.recordType==='returnedprofile',
      'AMH-red':searchResult.recordType==='rejectedprofile',
    }">

      <div class="card" v-if="searchResult.caseData && searchResult.recordType==='submittedprofile'">
        <div class="ribbon ribbon-top-right" v-if="searchResult.caseData.patientPrivacy!=='No'"><span>Privacy</span>
        </div>
        <p class="tag is-hoverable is-link is-light partner-tags search-card-stage">Submitted Profile</p>
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-128x128 is-rounded">
                <img v-bind:src="`${searchResult.caseData.featuredImage}`" alt="Patient"
                     class="image is-128x128 is-rounded">
              </figure>
            </div>
            <div class="media-content">
              <p class="items-list bottom-margin-title title is-4"> {{ searchResult.caseData.patientName }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Age:</strong> {{
                  searchResult.caseData.patientDob
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery Required:</strong>
                {{ searchResult.caseData.surgeryRequired }}</p>
              <p class="items-list items-list subtitle is-6 no-margin-p has-text-left"><strong>Estimated Surgery
                Date:</strong>
                {{ searchResult.caseData.estimatedSurgeryDay }} ({{ searchResult.caseData.diffToEstimatesSurgeryText }})
              </p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Partner:</strong>
                {{ searchResult.caseData.partnerIdentity }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Condition:</strong>
                {{ searchResult.caseData.patientCondition }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Case ID:</strong> {{
                  searchResult.caseData.profileIdentifier
                }}</p>
            </div>
          </div>
          <div class="content">
            <p class="items-list">This profile was submitted on <strong>{{
                searchResult.caseData.profileCreationDate
              }}</strong> by
              <strong>{{ searchResult.caseData.repName }}</strong></p>
            <p class="items-list has-text-left"><strong>Safe Ask:</strong> {{ searchResult.caseData.safeAskAmount }}</p>
          </div>
        </div>
        <footer class="card-footer">
          <a href="#" class="card-footer-item"
             v-on:click="viewProfileData(searchResult.caseData.profileIdentifier,true)">Details</a>
        </footer>
      </div>
      <div class="card" v-if="searchResult.caseData && searchResult.recordType==='approvedprofile'">
        <div class="ribbon ribbon-top-right" v-if="searchResult.caseData.patientPrivacy!=='No'"><span>Privacy</span>
        </div>
        <p class="tag is-hoverable is-primary is-light partner-tags search-card-stage">Approved Profile</p>
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-128x128 is-rounded">
                <img v-bind:src="`${searchResult.caseData.featuredImage}`" alt="Patient"
                     class="image is-128x128 is-rounded">
              </figure>
            </div>
            <div class="media-content">
              <p class="items-list bottom-margin-title title is-4"> {{ searchResult.caseData.patientName }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Age:</strong> {{
                  searchResult.caseData.patientDob
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery Required:</strong>
                {{ searchResult.caseData.surgeryRequired }}</p>
              <p class="items-list items-list subtitle is-6 no-margin-p has-text-left"><strong>Estimated Surgery
                Date:</strong>
                {{ searchResult.caseData.estimatedSurgeryDay }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Partner:</strong>
                {{ searchResult.caseData.partnerIdentity }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Condition:</strong>
                {{ searchResult.caseData.patientCondition }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Case ID:</strong> {{
                  searchResult.caseData.profileIdentifier
                }}</p>
            </div>
          </div>
          <div class="content">
            <p class="items-list has-text-left">Submitted on <strong>{{
                searchResult.caseData.profileCreationDate
              }}</strong> by
              <strong>{{ searchResult.caseData.repName }}</strong></p>
            <p class="items-list has-text-left">Approved on <strong>{{ searchResult.caseData.approved_at }}</strong> by
              <strong>{{ searchResult.caseData.approved_by }}</strong></p>
            <p class="items-list has-text-left"><strong>Safe Ask:</strong> {{ searchResult.caseData.safeAskAmount }}</p>
          </div>
        </div>
        <footer class="card-footer">
          <a href="#" class="card-footer-item" v-if="loginData.role==='Representative'"
             v-on:click="startFeedbackForm(searchResult.caseData.profileIdentifier)"
          >Feedback</a>
          <a href="#" class="card-footer-item" v-if="loginData.role==='Coordinator'"
             v-on:click="viewProfileData(searchResult.caseData.profileIdentifier,false)">Comment</a>
        </footer>
      </div>
      <div class="card" v-if="searchResult.caseData && searchResult.recordType==='returnedprofile'">
        <div class="ribbon ribbon-top-right" v-if="searchResult.caseData.patientPrivacy!=='No'"><span>Privacy</span>
        </div>
        <p class="tag is-hoverable is-warning is-light partner-tags search-card-stage">Returned Profile</p>
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-128x128 is-rounded">
                <img v-bind:src="`${searchResult.caseData.featuredImage}`" alt="Patient"
                     class="image is-128x128 is-rounded"
                     v-if="searchResult.caseData.featuredImage!==''">
                <img
                    v-bind:src="`${placeholdersBaseUrl}/profile/placeholder/personPlaceholder.png`"
                    alt="Med Rep" class="image is-128x128 is-rounded" v-else>
              </figure>
            </div>
            <div class="media-content">
              <p class="items-list bottom-margin-title title is-4"> {{ searchResult.caseData.patientName }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Creation Date:</strong> {{
                  searchResult.caseData.profileCreationDate
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Case Id:</strong> {{
                  searchResult.caseData.profileIdentifier
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-centered is-underlined">Returning Information</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"
                 v-for="(returns_data, index) in searchResult.caseData.returns_data" v-bind:key="index"><span
                  class="returned-arrow">&rArr;</span>
                Returned by <strong>{{ returns_data.returned_by }}</strong> on {{
                  returns_data.returned_at
                }}<br>
                Reason: <strong>{{ returns_data.returned_reason }}</strong></p>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <a href="#" class="card-footer-item"
             v-on:click="loadReturnedProfileForm(searchResult.caseData.profileIdentifier)"
             v-if="loginData.role==='Representative'">Draft</a>
          <a href="#" class="card-footer-item" v-on:click="deleteProfileForm(searchResult.caseData.profileIdentifier)"
             v-if="loginData.role==='Representative'">Delete</a>
        </footer>
      </div>
      <div class="card" v-if="searchResult.caseData && searchResult.recordType==='rejectedprofile'">
        <div class="ribbon ribbon-top-right" v-if="searchResult.caseData.patientPrivacy!=='No'"><span>Privacy</span>
        </div>
        <p class="tag is-hoverable is-danger is-light partner-tags search-card-stage">Rejected Profile</p>
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-128x128 is-rounded">
                <img v-bind:src="`${searchResult.caseData.featuredImage}`" alt="Patient"
                     class="image is-128x128 is-rounded">
              </figure>
            </div>
            <div class="media-content">
              <p class="items-list bottom-margin-title title is-4"> {{ searchResult.caseData.patientName }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Age:</strong> {{
                  searchResult.caseData.patientDob
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery Required:</strong>
                {{ searchResult.caseData.surgeryRequired }}</p>
              <p class="items-list items-list subtitle is-6 no-margin-p has-text-left"><strong>Estimated Surgery
                Date:</strong>
                {{ searchResult.caseData.estimatedSurgeryDay }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Partner:</strong>
                {{ searchResult.caseData.partnerIdentity }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Condition:</strong>
                {{ searchResult.caseData.patientCondition }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Case ID:</strong> {{
                  searchResult.caseData.profileIdentifier
                }}</p>
            </div>
          </div>
          <div class="content">
            <p class="items-list has-text-left">Submitted on <strong>{{
                searchResult.caseData.profileCreationDate
              }}</strong> by
              <strong>{{ searchResult.caseData.repName }}</strong></p>
            <p class="items-list has-text-left">Rejected on <strong>{{ searchResult.caseData.rejected_at }}</strong> by
              <strong>{{ searchResult.caseData.rejected_by }}</strong></p>
            <p class="items-list has-text-left">Rejection reason: <strong>
              {{ searchResult.caseData.rejection_reason }}</strong></p>
            <p class="items-list has-text-left"><strong>Safe Ask:</strong> {{ searchResult.caseData.safeAskAmount }}</p>
          </div>
        </div>
        <footer class="card-footer">
          <a href="#" class="card-footer-item"
             v-on:click="loadRejectedProfileForm(searchResult.caseData.profileIdentifier)">View</a>
        </footer>
      </div>
      <div class="card" v-if="searchResult.caseData && searchResult.recordType==='submittedfeedback'">
        <div class="ribbon ribbon-top-right" v-if="searchResult.caseData.profile.patientPrivacy!=='No'">
          <span>Privacy</span>
        </div>
        <p class="tag is-hoverable is-link is-light partner-tags search-card-stage">Submitted Feedback</p>
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-128x128 is-rounded">
                <img v-bind:src="`${searchResult.caseData.feedback.featuredImage}`" alt="Patient"
                     class="image is-128x128 is-rounded">
              </figure>
            </div>
            <div class="media-content">
              <p class="items-list bottom-margin-title title is-4"> {{
                  searchResult.caseData.profile.patientName
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Case ID:</strong> {{
                  searchResult.caseData.feedback.profileIdentifier
                }}
              </p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery Status:</strong> {{
                  searchResult.caseData.feedback.surgeryStatus
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery:</strong> {{
                  searchResult.caseData.feedback.actualSurgery
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Admission:</strong>
                {{ searchResult.caseData.feedback.admissionData }}</p>
              <p class="items-list items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery:</strong>
                {{ searchResult.caseData.feedback.surgeryData }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Discharge:</strong>
                {{ searchResult.caseData.feedback.dischargeData }}</p>
            </div>
          </div>
          <div class="content">
            <p class="items-list">This feedback was submitted on <strong>{{
                searchResult.caseData.feedback.submitted_at
              }}</strong> by
              <strong>{{ searchResult.caseData.feedback.submitted_by }}</strong></p>
            <p class="items-list has-text-left"><strong>Final Bill:</strong>
              {{ searchResult.caseData.feedback.finalBill }}</p>
          </div>
        </div>
        <footer class="card-footer">
          <a href="#" class="card-footer-item" v-if="loginData.role==='Coordinator'"
             v-on:click="QAFeedbackData(searchResult.caseData.feedback.profileIdentifier)">Details</a>
          <a href="#" class="card-footer-item" v-if="loginData.role==='Representative'"
             v-on:click="viewFeedbackData(searchResult.caseData.feedback.profileIdentifier)">View</a>
        </footer>
      </div>
      <div class="card" v-if="searchResult.caseData && searchResult.recordType==='returnedfeedback'">
        <div class="ribbon ribbon-top-right" v-if="searchResult.caseData.profile.patientPrivacy!=='No'">
          <span>Privacy</span>
        </div>
        <p class="tag is-hoverable is-link is-light partner-tags search-card-stage">Returned Feedback</p>

        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-128x128 is-rounded">
                <img v-bind:src="`${searchResult.caseData.feedback.featuredImage}`" alt="Patient"
                     class="image is-128x128 is-rounded">
              </figure>
            </div>
            <div class="media-content">
              <p class="items-list bottom-margin-title title is-4"> {{ searchResult.caseData.profile.patientName }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Case ID:</strong> {{
                  searchResult.caseData.feedback.profileIdentifier
                }}
              </p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery Status:</strong> {{
                  searchResult.caseData.feedback.surgeryStatus
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery:</strong> {{
                  searchResult.caseData.feedback.actualSurgery
                }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Admission:</strong>
                {{ searchResult.caseData.feedback.admissionData }}</p>
              <p class="items-list items-list subtitle is-6 no-margin-p has-text-left"><strong>Surgery:</strong>
                {{ searchResult.caseData.feedback.surgeryData }}</p>
              <p class="items-list subtitle is-6 no-margin-p has-text-left"><strong>Discharge:</strong>
                {{ searchResult.caseData.feedback.dischargeData }}</p>
            </div>
          </div>
          <div class="content">
            <p class="items-list">This feedback was submitted on <strong>{{
                searchResult.caseData.feedback.submitted_at
              }}</strong> by
              <strong>{{ searchResult.caseData.feedback.submitted_by }}</strong></p>

            <p class="items-list has-text-left"><strong>Final Bill:</strong>
              {{ searchResult.caseData.feedback.finalBill }}</p>

            <p class="items-list subtitle is-6 no-margin-p has-text-centered is-underlined">Returning Information</p>
            <p class="items-list subtitle is-6 no-margin-p has-text-left"
               v-for="(returns_data, index) in searchResult.caseData.feedback.returns_data" v-bind:key="index"><span
                class="returned-arrow">&rArr;</span>
              Returned by <strong>{{ returns_data.returned_by }}</strong> on <strong>{{
                  returns_data.returned_at
                }}</strong><br>
              Reason: <strong>{{ returns_data.returned_reason }}</strong></p>
          </div>
        </div>
        <footer class="card-footer">
          <a href="#" class="card-footer-item"
             v-on:click="editFeedbackForm(searchResult.caseData.feedback.profileIdentifier)"
             v-if="loginData.role==='Representative' && !inDraftFeedbacks(searchResult.caseData.feedback.profileIdentifier)">Amend</a>
          <span class="card-footer-item"
                v-if="loginData.role==='Representative' && inDraftFeedbacks(searchResult.caseData.feedback.profileIdentifier)">In Draft Feedbacks</span>
        </footer>


      </div>

    </li>

  </ol>
  <ModalsContainer/>
</template>

<style scoped>

.pills-container {
  overflow-x: scroll;
}

.hide-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.hide-scrollbar::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera, older Edge */
}

.margin-5-button {
  margin: 5px !important;
}

.notification-safeapp {
  margin: 0 !important;
  padding: 5px !important;
}

.item-counts {
  margin: 0 10px;
  background-color: black;
  color: white;
  font-weight: bold;
  padding: 10px;
  line-height: 10px;
  border-radius: 20px;
}

.amh-card {
  border-radius: 20px !important;
}

.amh-card div.card {
  border-radius: unset !important;
}

.amh-top-tabs ul {
  border-bottom-color: #fff !important;
}

.AMH-lightGray {
  background-color: #d9d8d8 !important;
}

.AMH-transitionGray {
  background-color: #767576 !important;
}

.AMH-darkGray {
  background-color: #221f20 !important;
}

.AMH-blue {
  background-color: #276eb6 !important;
}

.AMH-red {
  background-color: #ce3727 !important;
}

.AMH-yellow {
  background-color: #f8d246 !important;
}

.AMH-green {
  background-color: #4d9041 !important;
}

.partner-select, .amh-top-tabs, .card-type-select {
  margin-bottom: 10px;
}

.partner-tags {
  margin: 5px;
}

.is-hidden {
  display: none;
}

.is-visible {
  display: block;
}

.no-margin-p {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}

.bottom-margin-title {
  margin-bottom: 5px !important;
}

.card-list {
  padding: 1rem 0 0 0 !important;
}

* {
  box-sizing: border-box;
}

p.items-list {
  margin: 0;
}

ol.items-list {
  list-style: none;
  counter-reset: list;
  padding: 0 1rem;
}

li.items-list {
  --stop: calc(100% / var(--length) * var(--i));
  --l: 62%;
  --l2: 88%;
  --h: calc((var(--i) - 1) * (180 / var(--length)));
  --c1: hsl(var(--h), 71%, var(--l));
  --c2: hsl(var(--h), 71%, var(--l2));

  position: relative;
  counter-increment: list;
  max-width: 45rem;
  margin: 2rem auto;
  padding: 2rem 1rem 1rem;
  box-shadow: 0.1rem 0.1rem 1.5rem rgba(0, 0, 0, 0.3);
  border-radius: 0.25rem;
  overflow: hidden;
  background-color: white;
}

li.items-list::before {
  content: '';
  display: block;
  width: 100%;
  height: 1rem;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(to right, var(--c1) var(--stop), var(--c2) var(--stop));
}

h3.items-list {
  display: flex;
  align-items: baseline;
  margin: 0 0 1rem;
  color: rgb(70 70 70);
}

h3.items-list::before {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  margin-right: 1rem;
  width: 3rem;
  height: 3rem;
  content: counter(list);
  padding: 1rem;
  border-radius: 50%;
  background-color: var(--c1);
  color: white;
}

@media (min-width: 40em) {
  li.items-list {
    margin: 3rem auto;
    padding: 3rem 2rem 2rem;
  }

  h3.items-list {
    font-size: 2.25rem;
    margin: 0 0 2rem;
  }

  h3.items-list::before {
    margin-right: 1.5rem;
  }
}

.returned-arrow {
  color: red;
}

@media screen and (max-width: 768px) {
  .field.has-addons,
  .field.is-grouped {
    display: block;

    .control:not(:last-child) {
      margin-right: 0;
      margin-bottom: 1em;

      button {
        width: 100%;
      }
    }
  }

  .button.is-fullwidth-mobile {
    display: flex;
    width: 100%;
  }
}

.user-card {
  padding-bottom: 0 !important;
}

.user-card-media {
  margin-bottom: 0 !important;
}

.search-card-stage {
  position: absolute;
  left: 0;
  margin: 0 !important;
}


.ribbon {
  width: 100px;
  height: 100px;
  overflow: hidden;
  position: absolute;
}

.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: '';
  display: block;
  border: 5px solid #2980b9;
}

.ribbon span {
  position: absolute;
  display: block;
  width: 170px;
  padding: 5px 0;
  background-color: #7a7a7a;
  box-shadow: 0 5px 10px rgba(0, 0, 0, .1);
  color: #fff;
  font: 700 18px/1 'Lato', sans-serif;
  text-shadow: 0 1px 1px rgba(0, 0, 0, .2);
  text-transform: uppercase;
  text-align: center;
}

.ribbon-top-left {
  top: -10px;
  left: -10px;
}

.ribbon-top-left::before,
.ribbon-top-left::after {
  border-top-color: transparent;
  border-left-color: transparent;
}

.ribbon-top-left::before {
  top: 0;
  right: 0;
}

.ribbon-top-left::after {
  bottom: 0;
  left: 0;
}

.ribbon-top-left span {
  right: -25px;
  top: 30px;
  transform: rotate(-45deg);
}

.ribbon-top-right {
  top: 0;
  right: 0;
}

.ribbon-top-right::before,
.ribbon-top-right::after {
  border-top-color: transparent;
  border-right-color: transparent;
}

.ribbon-top-right::before {
  top: 0;
  left: 0;
}

.ribbon-top-right::after {
  bottom: 0;
  right: 0;
}

.ribbon-top-right span {
  left: -20px;
  top: 20px;
  transform: rotate(45deg);
}

.ribbon-bottom-left {
  bottom: -10px;
  left: -10px;
}

.ribbon-bottom-left::before,
.ribbon-bottom-left::after {
  border-bottom-color: transparent;
  border-left-color: transparent;
}

.ribbon-bottom-left::before {
  bottom: 0;
  right: 0;
}

.ribbon-bottom-left::after {
  top: 0;
  left: 0;
}

.ribbon-bottom-left span {
  right: -25px;
  bottom: 30px;
  transform: rotate(225deg);
}

.ribbon-bottom-right {
  bottom: -10px;
  right: -10px;
}

.ribbon-bottom-right::before,
.ribbon-bottom-right::after {
  border-bottom-color: transparent;
  border-right-color: transparent;
}

.ribbon-bottom-right::before {
  bottom: 0;
  left: 0;
}

.ribbon-bottom-right::after {
  top: 0;
  right: 0;
}

.ribbon-bottom-right span {
  left: -25px;
  bottom: 30px;
  transform: rotate(-225deg);
}

.box-with-no-bg {
  background-color: transparent !important;
}

.emergency-bg {
  background: linear-gradient(135deg, rgba(206, 55, 39, 1) 3%, rgba(248, 210, 70, 1) 92%);
}

</style>